import 'core-js/modules/es.error.to-string.js';
import 'core-js/modules/es.date.to-string.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.regexp.to-string.js';
import Color from 'color';

var colorTokens = {
  /**
   * text-icon--strong
   * -----------------
   * Text and icon color for main body- and header text.
   */
  'text-icon--strong': Color.rgb([0, 0, 0]).alpha(0.9).toString(),
  /**
   * text-icon--medium
   * -----------------
   * Text and icon color for secondary text, comments, etc.
   */
  'text-icon--medium': Color.rgb([0, 0, 0]).alpha(0.7).toString(),
  /**
   * text-icon--muted
   * ----------------
   * Text and icon color for hints or inputs placeholders.
   */
  'text-icon--muted': Color.rgb([0, 0, 0]).alpha(0.55).toString(),
  /**
   * text-icon--on-contrast--strong
   * ------------------------------
   * Text and icon color to be used on high-contrast surfaces (action-strong and all status-[]-strong colors).
   */
  'text-icon--on-contrast--strong': Color.rgb([255, 255, 255]).toString(),
  /**
   * text-icon--interactive--default
   * -------------------------------
   * Text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'text-icon--interactive--default': Color.rgb([63, 86, 181]).toString(),
  /**
   * text-icon--interactive--hover
   * -----------------------------
   * Hover state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'text-icon--interactive--hover': Color.rgb([52, 71, 150]).toString(),
  /**
   * text-icon--interactive--pressed
   * -------------------------------
   * Pressed state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'text-icon--interactive--pressed': Color.rgb([41, 55, 128]).toString(),
  /**
   * text-icon--interactive--disabled
   * --------------------------------
   * Disabled state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'text-icon--interactive--disabled': Color.rgb([140, 140, 140]).toString(),
  /**
   * text-icon--status-neutral
   * -------------------------
   * Text and icon color for neutral status, or to highlight information.
   */
  'text-icon--status-neutral': Color.rgb([48, 89, 179]).toString(),
  /**
   * text-icon--status-success
   * -------------------------
   * Text and icon color for positive status, success, health.
   */
  'text-icon--status-success': Color.rgb([44, 105, 53]).toString(),
  /**
   * text-icon--status-warning
   * -------------------------
   * Text and icon color for warnings, minor issues, minor errors.
   */
  'text-icon--status-warning': Color.rgb([143, 76, 15]).toString(),
  /**
   * text-icon--status-critical
   * --------------------------
   * Text and icon color for critical information or major issues, danger, destructive action or major error.
   */
  'text-icon--status-critical': Color.rgb([168, 54, 28]).toString(),
  /**
   * text-icon--status-undefined
   * ---------------------------
   * Text and icon color for undefined state, default, unknown status, no-status.
   */
  'text-icon--status-undefined': Color.rgb([93, 93, 93]).toString(),
  /**
   * border--muted
   * -------------
   * Default border color for screen dividers and generic non-interactive borders.
   */
  'border--muted': Color.rgb([217, 217, 217]).toString(),
  /**
   * border--interactive--default
   * ----------------------------
   * Border color for outlined components or controls (e.g. input, select, card).
   */
  'border--interactive--default': Color.rgb([83, 88, 127]).alpha(0.16).toString(),
  /**
   * border--interactive--default--alt
   * ---------------------------------
   * Alternative border color for small outlined components or controls (e.g. checkbox).
   */
  'border--interactive--default--alt': Color.rgb([83, 88, 127]).alpha(0.24).toString(),
  /**
   * border--interactive--hover
   * --------------------------
   * Hover state border color for outlined components or controls.
   */
  'border--interactive--hover': Color.rgb([110, 133, 252]).toString(),
  /**
   * border--interactive--toggled-default
   * ------------------------------------
   * Toggled (active, selected) state border color for outlined components or controls.
   */
  'border--interactive--toggled-default': Color.rgb([74, 103, 251]).toString(),
  /**
   * border--interactive--toggled-hover
   * ----------------------------------
   * Hover state of a toggled (active, selected) state border color for outlined components or controls.
   */
  'border--interactive--toggled-hover': Color.rgb([66, 85, 187]).toString(),
  /**
   * border--interactive--toggled-pressed
   * ------------------------------------
   * Pressed state of a toggled (active, selected) state border color for outlined components or controls.
   */
  'border--interactive--toggled-pressed': Color.rgb([43, 58, 136]).toString(),
  /**
   * border--interactive--disabled
   * -----------------------------
   * Disabled border color for interactive elements (e.g. checkboxes, selection control, inputs).
   */
  'border--interactive--disabled': Color.rgb([0, 0, 0]).alpha(0.06).toString(),
  /**
   * border--status-neutral--muted
   * -----------------------------
   * Default (muted) border color for neutral status.
   */
  'border--status-neutral--muted': Color.rgb([64, 120, 240]).alpha(0.2).toString(),
  /**
   * border--status-neutral--strong
   * ------------------------------
   * Strong (saturated) border color for neutral status.
   */
  'border--status-neutral--strong': Color.rgb([64, 120, 240]).toString(),
  /**
   * border--status-success--muted
   * -----------------------------
   * Default (muted) border color for success status.
   */
  'border--status-success--muted': Color.rgb([57, 162, 99]).alpha(0.2).toString(),
  /**
   * border--status-success--strong
   * ------------------------------
   * Strong (saturated) border color for success status.
   */
  'border--status-success--strong': Color.rgb([57, 162, 99]).toString(),
  /**
   * border--status-warning--muted
   * -----------------------------
   * Default (muted) border color for warning status.
   */
  'border--status-warning--muted': Color.rgb([255, 187, 0]).alpha(0.2).toString(),
  /**
   * border--status-warning--strong
   * ------------------------------
   * Strong (saturated) border color for warning status.
   */
  'border--status-warning--strong': Color.rgb([235, 155, 0]).toString(),
  /**
   * border--status-critical--muted
   * ------------------------------
   * Default (muted) border color for critical status.
   */
  'border--status-critical--muted': Color.rgb([223, 66, 55]).alpha(0.2).toString(),
  /**
   * border--status-critical--strong
   * -------------------------------
   * Strong (saturated) border color for critical status.
   */
  'border--status-critical--strong': Color.rgb([229, 59, 56]).toString(),
  /**
   * border--status-undefined--muted
   * -------------------------------
   * Default (muted) border color for undefined status.
   */
  'border--status-undefined--muted': Color.rgb([102, 102, 102]).alpha(0.2).toString(),
  /**
   * border--status-undefined--strong
   * --------------------------------
   * Strong (saturated) border color for undefined status.
   */
  'border--status-undefined--strong': Color.rgb([102, 102, 102]).toString(),
  /**
   * surface--muted
   * --------------
   * Default surface color for screens (pages) and UI background.
   */
  'surface--muted': Color.rgb([255, 255, 255]).toString(),
  /**
   * surface--medium
   * ---------------
   * Alternative surface color for sreens (pages) and UI background. Also used forstriped tables.
   */
  'surface--medium': Color.rgb([250, 250, 250]).toString(),
  /**
   * surface--strong
   * ---------------
   * Accent surface color for screens (pages) and UI background. Used tohelp cards and islands on-top stand out more.
   */
  'surface--strong': Color.rgb([245, 245, 245]).toString(),
  /**
   * surface--misc-transparent
   * -------------------------
   * Transparent surface token.
   */
  'surface--misc-transparent': Color.rgb([255, 255, 255]).alpha(0).toString(),
  /**
   * surface--misc-backdrop
   * ----------------------
   * Surface color for backdrops behind modal windows.
   */
  'surface--misc-backdrop': Color.rgb([71, 71, 71]).alpha(0.4).toString(),
  /**
   * surface--misc-canvas
   * --------------------
   * Surface color for canvases, interactive boards, pipelines, document editors.
   */
  'surface--misc-canvas': Color.rgb([245, 245, 245]).toString(),
  /**
   * surface--misc-code--muted
   * -------------------------
   * Surface color for code editors and code examples (snippets)
   */
  'surface--misc-code--muted': Color.rgb([50, 56, 83]).alpha(0.04).toString(),
  /**
   * surface--misc-code--medium
   * --------------------------
   * Surface color for decorative elements of code editors and code examples (snippets)
   */
  'surface--misc-code--medium': Color.rgb([50, 56, 83]).alpha(0.06).toString(),
  /**
   * surface--interactive--hover
   * ---------------------------
   * Generic hover state surface color for interactive elements without any specified background (e.g. table rows).
   */
  'surface--interactive--hover': Color.rgb([34, 42, 83]).alpha(0.06).toString(),
  /**
   * surface--interactive--pressed
   * -----------------------------
   * Generic pressed state surface color for interactive elements without any specified background (e.g. table rows).
   */
  'surface--interactive--pressed': Color.rgb([34, 42, 83]).alpha(0.1).toString(),
  /**
   * surface--interactive--toggled-default
   * -------------------------------------
   * Toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'surface--interactive--toggled-default': Color.rgb([74, 103, 251]).alpha(0.08).toString(),
  /**
   * surface--interactive--toggled-hover
   * -----------------------------------
   * Hover state of a toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'surface--interactive--toggled-hover': Color.rgb([74, 103, 251]).alpha(0.12).toString(),
  /**
   * surface--interactive--toggled-pressed
   * -------------------------------------
   * Pressed state of a toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'surface--interactive--toggled-pressed': Color.rgb([74, 103, 251]).alpha(0.18).toString(),
  /**
   * surface--interactive--disabled
   * ------------------------------
   * Disabled state surface color for interactive elements (e.g. buttons, inputs).
   */
  'surface--interactive--disabled': Color.rgb([0, 0, 0]).alpha(0.03).toString(),
  /**
   * surface--interactive--disabled--alt
   * -----------------------------------
   * Alternative disabled state surface color for duo-toned components (e.g. checkbox)
   */
  'surface--interactive--disabled--alt': Color.rgb([0, 0, 0]).alpha(0.16).toString(),
  /**
   * surface--action--strong--default
   * --------------------------------
   * Surface color for primary actions (e.g. primary button).
   */
  'surface--action--strong--default': Color.rgb([74, 103, 251]).toString(),
  /**
   * surface--action--strong--hover
   * ------------------------------
   * Hover state surface color for primary actions (e.g. primary button).
   */
  'surface--action--strong--hover': Color.rgb([58, 74, 163]).toString(),
  /**
   * surface--action--strong--pressed
   * --------------------------------
   * Pressed state surface color for primary actions (e.g. primary button).
   */
  'surface--action--strong--pressed': Color.rgb([43, 58, 136]).toString(),
  /**
   * surface--action--muted--default
   * -------------------------------
   * Surface color for secondary actions components (e.g. secondary button).
   */
  'surface--action--muted--default': Color.rgb([83, 88, 127]).alpha(0.08).toString(),
  /**
   * surface--action--muted--default--alt
   * ------------------------------------
   * Alternative surface color for smaller secondary actions components (e.g. switch).
   */
  'surface--action--muted--default--alt': Color.rgb([83, 88, 127]).alpha(0.24).toString(),
  /**
   * surface--action--muted--hover
   * -----------------------------
   * Hover state surface color for secondary actions (e.g. secondary button).
   */
  'surface--action--muted--hover': Color.rgb([83, 88, 127]).alpha(0.12).toString(),
  /**
   * surface--action--muted--pressed
   * -------------------------------
   * Pressed state surface color for secondary actions (e.g. secondary button).
   */
  'surface--action--muted--pressed': Color.rgb([83, 88, 127]).alpha(0.16).toString(),
  /**
   * surface--on--action--muted--default
   * -----------------------------------
   * Default state surface color to be used on top of secondary actions (e.g. segmented control).
   */
  'surface--on--action--muted--default': Color.rgb([255, 255, 255]).toString(),
  /**
   * surface--on--action--muted--hover
   * ---------------------------------
   * Hover state surface color to be used on top of secondary actions (e.g. segmented control).
   */
  'surface--on--action--muted--hover': Color.rgb([255, 255, 255]).alpha(0.5).toString(),
  /**
   * surface--status-neutral--muted--default
   * ---------------------------------------
   * Default (muted) surface color for neutral status. Used for smaller elements like label.
   */
  'surface--status-neutral--muted--default': Color.rgb([64, 120, 240]).alpha(0.1).toString(),
  /**
   * surface--status-neutral--muted--default--alt
   * --------------------------------------------
   * Alternative muted surface color for neutral status. Used for bigger elements like infobox.
   */
  'surface--status-neutral--muted--default--alt': Color.rgb([64, 120, 240]).alpha(0.06).toString(),
  /**
   * surface--status-neutral--muted--hover
   * -------------------------------------
   * Hover state of a muted surface color for neutral status.
   */
  'surface--status-neutral--muted--hover': Color.rgb([64, 120, 240]).alpha(0.15).toString(),
  /**
   * surface--status-neutral--muted--pressed
   * ---------------------------------------
   * Pressed state of a muted surface color for neutral status.
   */
  'surface--status-neutral--muted--pressed': Color.rgb([64, 120, 240]).alpha(0.2).toString(),
  /**
   * surface--status-neutral--strong--default
   * ----------------------------------------
   * Strong (saturated) surface color for neutral status.
   */
  'surface--status-neutral--strong--default': Color.rgb([57, 107, 215]).toString(),
  /**
   * surface--status-neutral--strong--hover
   * --------------------------------------
   * Hover state of a strong (saturated) surface color for neutral status.
   */
  'surface--status-neutral--strong--hover': Color.rgb([54, 100, 201]).toString(),
  /**
   * surface--status-neutral--strong--pressed
   * ----------------------------------------
   * Pressed state of a strong (saturated) surface color for neutral status.
   */
  'surface--status-neutral--strong--pressed': Color.rgb([50, 94, 189]).toString(),
  /**
   * surface--status-success--muted--default
   * ---------------------------------------
   * Default (muted) surface color for success status. Used for smaller elements like label.
   */
  'surface--status-success--muted--default': Color.rgb([57, 162, 99]).alpha(0.1).toString(),
  /**
   * surface--status-success--muted--default--alt
   * --------------------------------------------
   * Alternative muted surface color for success status. Used for bigger elements like infobox.
   */
  'surface--status-success--muted--default--alt': Color.rgb([57, 162, 99]).alpha(0.06).toString(),
  /**
   * surface--status-success--muted--hover
   * -------------------------------------
   * Hover state of a muted surface color for success status.
   */
  'surface--status-success--muted--hover': Color.rgb([57, 162, 99]).alpha(0.15).toString(),
  /**
   * surface--status-success--muted--pressed
   * ---------------------------------------
   * Pressed state of a muted surface color for success status.
   */
  'surface--status-success--muted--pressed': Color.rgb([57, 162, 99]).alpha(0.18).toString(),
  /**
   * surface--status-success--strong--default
   * ----------------------------------------
   * Strong (saturated) surface color for success status.
   */
  'surface--status-success--strong--default': Color.rgb([44, 133, 79]).toString(),
  /**
   * surface--status-success--strong--hover
   * --------------------------------------
   * Hover state of a strong (saturated) surface color for success status.
   */
  'surface--status-success--strong--hover': Color.rgb([39, 117, 70]).toString(),
  /**
   * surface--status-success--strong--pressed
   * ----------------------------------------
   * Pressed state of a strong (saturated) surface color for success status.
   */
  'surface--status-success--strong--pressed': Color.rgb([33, 102, 61]).toString(),
  /**
   * surface--status-warning--muted--default
   * ---------------------------------------
   * Default (muted) surface color for warning status. Used for smaller elements like label.
   */
  'surface--status-warning--muted--default': Color.rgb([255, 187, 0]).alpha(0.12).toString(),
  /**
   * surface--status-warning--muted--default--alt
   * --------------------------------------------
   * Alternative muted surface color for warning status. Used for bigger elements like infobox.
   */
  'surface--status-warning--muted--default--alt': Color.rgb([255, 187, 0]).alpha(0.06).toString(),
  /**
   * surface--status-warning--muted--hover
   * -------------------------------------
   * Hover state of a muted surface color for warning status.
   */
  'surface--status-warning--muted--hover': Color.rgb([255, 187, 0]).alpha(0.15).toString(),
  /**
   * surface--status-warning--muted--pressed
   * ---------------------------------------
   * Pressed state of a muted surface color for warning status.
   */
  'surface--status-warning--muted--pressed': Color.rgb([255, 187, 0]).alpha(0.2).toString(),
  /**
   * surface--status-warning--strong--default
   * ----------------------------------------
   * Strong (saturated) surface color for warning status.
   */
  'surface--status-warning--strong--default': Color.rgb([186, 93, 0]).toString(),
  /**
   * surface--status-warning--strong--hover
   * --------------------------------------
   * Hover state of a strong (saturated) surface color for warning status.
   */
  'surface--status-warning--strong--hover': Color.rgb([176, 88, 0]).toString(),
  /**
   * surface--status-warning--strong--pressed
   * ----------------------------------------
   * Pressed state of a strong (saturated) surface color for warning status.
   */
  'surface--status-warning--strong--pressed': Color.rgb([166, 77, 0]).toString(),
  /**
   * surface--status-critical--muted--default
   * ----------------------------------------
   * Default (muted) surface color for critical status. Used for smaller elements like label.
   */
  'surface--status-critical--muted--default': Color.rgb([223, 64, 55]).alpha(0.08).toString(),
  /**
   * surface--status-critical--muted--default--alt
   * ---------------------------------------------
   * Alternative muted surface color for critical status. Used for bigger elements like infobox.
   */
  'surface--status-critical--muted--default--alt': Color.rgb([223, 64, 55]).alpha(0.06).toString(),
  /**
   * surface--status-critical--muted--hover
   * --------------------------------------
   * Hover state of a muted surface color for critical status.
   */
  'surface--status-critical--muted--hover': Color.rgb([223, 64, 55]).alpha(0.12).toString(),
  /**
   * surface--status-critical--muted--pressed
   * ----------------------------------------
   * Pressed state of a muted surface color for critical status.
   */
  'surface--status-critical--muted--pressed': Color.rgb([223, 64, 55]).alpha(0.16).toString(),
  /**
   * surface--status-critical--strong--default
   * -----------------------------------------
   * Strong (saturated) surface color for critical status.
   */
  'surface--status-critical--strong--default': Color.rgb([189, 36, 28]).toString(),
  /**
   * surface--status-critical--strong--hover
   * ---------------------------------------
   * Hover state of a strong (saturated) surface color for critical status.
   */
  'surface--status-critical--strong--hover': Color.rgb([173, 33, 26]).toString(),
  /**
   * surface--status-critical--strong--pressed
   * -----------------------------------------
   * Pressed state of a strong (saturated) surface color for critical status.
   */
  'surface--status-critical--strong--pressed': Color.rgb([158, 30, 24]).toString(),
  /**
   * surface--status-undefined--muted--default
   * -----------------------------------------
   * Default (muted) surface color for undefined status. Used for smaller elements like label.
   */
  'surface--status-undefined--muted--default': Color.rgb([102, 102, 102]).alpha(0.1).toString(),
  /**
   * surface--status-undefined--muted--default--alt
   * ----------------------------------------------
   * Alternative muted surface color for undefined status. Used for bigger elements like infobox.
   */
  'surface--status-undefined--muted--default--alt': Color.rgb([102, 102, 102]).alpha(0.06).toString(),
  /**
   * surface--status-undefined--muted--hover
   * ---------------------------------------
   * Hover state of a muted surface color for undefined status.
   */
  'surface--status-undefined--muted--hover': Color.rgb([102, 102, 102]).alpha(0.14).toString(),
  /**
   * surface--status-undefined--muted--pressed
   * -----------------------------------------
   * Pressed state of a muted surface color for undefined status.
   */
  'surface--status-undefined--muted--pressed': Color.rgb([102, 102, 102]).alpha(0.2).toString(),
  /**
   * surface--status-undefined--strong--default
   * ------------------------------------------
   * Strong (saturated) surface color for undefined status.
   */
  'surface--status-undefined--strong--default': Color.rgb([117, 117, 117]).toString(),
  /**
   * surface--status-undefined--strong--hover
   * ----------------------------------------
   * Hover state of a strong (saturated) surface color for undefined status.
   */
  'surface--status-undefined--strong--hover': Color.rgb([102, 102, 102]).toString(),
  /**
   * surface--status-undefined--strong--pressed
   * ------------------------------------------
   * Pressed state of a strong (saturated) surface color for undefined status.
   */
  'surface--status-undefined--strong--pressed': Color.rgb([56, 57, 62]).toString(),
  /**
   * text-icon--strong--inverted
   * ---------------------------
   * Text and icon color for main body- and header text.
   */
  'text-icon--strong--inverted': Color.rgb([255, 255, 255]).alpha(0.95).toString(),
  /**
   * text-icon--medium--inverted
   * ---------------------------
   * Text and icon color for secondary text, comments, etc.
   */
  'text-icon--medium--inverted': Color.rgb([255, 255, 255]).alpha(0.82).toString(),
  /**
   * text-icon--muted--inverted
   * --------------------------
   * Text and icon color for hints or inputs placeholders.
   */
  'text-icon--muted--inverted': Color.rgb([255, 255, 255]).alpha(0.72).toString(),
  /**
   * text-icon--on-contrast--strong--inverted
   * ----------------------------------------
   * Text and icon color to be used on high-contrast surfaces (action-strong and all status-[]-strong colors).
   */
  'text-icon--on-contrast--strong--inverted': Color.rgb([38, 38, 38]).toString(),
  /**
   * text-icon--interactive--default--inverted
   * -----------------------------------------
   * Text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'text-icon--interactive--default--inverted': Color.rgb([219, 225, 254]).toString(),
  /**
   * text-icon--interactive--hover--inverted
   * ---------------------------------------
   * Hover state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'text-icon--interactive--hover--inverted': Color.rgb([237, 240, 255]).toString(),
  /**
   * text-icon--interactive--pressed--inverted
   * -----------------------------------------
   * Pressed state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'text-icon--interactive--pressed--inverted': Color.rgb([246, 247, 255]).toString(),
  /**
   * text-icon--interactive--disabled--inverted
   * ------------------------------------------
   * Disabled state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'text-icon--interactive--disabled--inverted': Color.rgb([255, 255, 255]).alpha(0.4).toString(),
  /**
   * text-icon--status-neutral--inverted
   * -----------------------------------
   * Text and icon color for neutral status, or to highlight information.
   */
  'text-icon--status-neutral--inverted': Color.rgb([188, 208, 250]).toString(),
  /**
   * text-icon--status-success--inverted
   * -----------------------------------
   * Text and icon color for positive status, success, health.
   */
  'text-icon--status-success--inverted': Color.rgb([172, 219, 179]).toString(),
  /**
   * text-icon--status-warning--inverted
   * -----------------------------------
   * Text and icon color for warnings, minor issues, minor errors.
   */
  'text-icon--status-warning--inverted': Color.rgb([252, 199, 98]).toString(),
  /**
   * text-icon--status-critical--inverted
   * ------------------------------------
   * Text and icon color for critical information or major issues, danger, destructive action or major error.
   */
  'text-icon--status-critical--inverted': Color.rgb([249, 195, 184]).toString(),
  /**
   * text-icon--status-undefined--inverted
   * -------------------------------------
   * Text and icon color for undefined state, default, unknown status, no-status.
   */
  'text-icon--status-undefined--inverted': Color.rgb([208, 208, 208]).toString(),
  /**
   * border--muted--inverted
   * -----------------------
   * Default border color for screen dividers and generic non-interactive borders.
   */
  'border--muted--inverted': Color.rgb([81, 81, 81]).toString(),
  /**
   * border--interactive--default--inverted
   * --------------------------------------
   * Border color for outlined components or controls (e.g. input, select, card).
   */
  'border--interactive--default--inverted': Color.rgb([255, 255, 255]).alpha(0.2).toString(),
  /**
   * border--interactive--default--alt--inverted
   * -------------------------------------------
   * Alternative border color for small outlined components or controls (e.g. checkbox).
   */
  'border--interactive--default--alt--inverted': Color.rgb([255, 255, 255]).alpha(0.28).toString(),
  /**
   * border--interactive--hover--inverted
   * ------------------------------------
   * Hover state border color for outlined components or controls.
   */
  'border--interactive--hover--inverted': Color.rgb([232, 232, 232]).toString(),
  /**
   * border--interactive--toggled-default--inverted
   * ----------------------------------------------
   * Toggled (active, selected) state border color for outlined components or controls.
   */
  'border--interactive--toggled-default--inverted': Color.rgb([255, 255, 255]).toString(),
  /**
   * border--interactive--toggled-hover--inverted
   * --------------------------------------------
   * Hover state of a toggled (active, selected) state border color for outlined components or controls.
   */
  'border--interactive--toggled-hover--inverted': Color.rgb([232, 232, 232]).toString(),
  /**
   * border--interactive--toggled-pressed--inverted
   * ----------------------------------------------
   * Pressed state of a toggled (active, selected) state border color for outlined components or controls.
   */
  'border--interactive--toggled-pressed--inverted': Color.rgb([218, 218, 218]).toString(),
  /**
   * border--interactive--disabled--inverted
   * ---------------------------------------
   * Disabled border color for interactive elements (e.g. checkboxes, selection control, inputs).
   */
  'border--interactive--disabled--inverted': Color.rgb([255, 255, 255]).alpha(0.08).toString(),
  /**
   * border--status-neutral--muted--inverted
   * ---------------------------------------
   * Default (muted) border color for neutral status.
   */
  'border--status-neutral--muted--inverted': Color.rgb([64, 120, 240]).alpha(0.4).toString(),
  /**
   * border--status-neutral--strong--inverted
   * ----------------------------------------
   * Strong (saturated) border color for neutral status.
   */
  'border--status-neutral--strong--inverted': Color.rgb([64, 120, 240]).toString(),
  /**
   * border--status-success--muted--inverted
   * ---------------------------------------
   * Default (muted) border color for success status.
   */
  'border--status-success--muted--inverted': Color.rgb([74, 178, 91]).alpha(0.4).toString(),
  /**
   * border--status-success--strong--inverted
   * ----------------------------------------
   * Strong (saturated) border color for success status.
   */
  'border--status-success--strong--inverted': Color.rgb([74, 178, 91]).toString(),
  /**
   * border--status-warning--muted--inverted
   * ---------------------------------------
   * Default (muted) border color for warning status.
   */
  'border--status-warning--muted--inverted': Color.rgb([250, 174, 26]).alpha(0.4).toString(),
  /**
   * border--status-warning--strong--inverted
   * ----------------------------------------
   * Strong (saturated) border color for warning status.
   */
  'border--status-warning--strong--inverted': Color.rgb([250, 174, 26]).toString(),
  /**
   * border--status-critical--muted--inverted
   * ----------------------------------------
   * Default (muted) border color for critical status.
   */
  'border--status-critical--muted--inverted': Color.rgb([238, 76, 40]).alpha(0.4).toString(),
  /**
   * border--status-critical--strong--inverted
   * -----------------------------------------
   * Strong (saturated) border color for critical status.
   */
  'border--status-critical--strong--inverted': Color.rgb([238, 76, 40]).toString(),
  /**
   * border--status-undefined--muted--inverted
   * -----------------------------------------
   * Default (muted) border color for undefined status.
   */
  'border--status-undefined--muted--inverted': Color.rgb([79, 79, 79]).alpha(0.4).toString(),
  /**
   * border--status-undefined--strong--inverted
   * ------------------------------------------
   * Strong (saturated) border color for undefined status.
   */
  'border--status-undefined--strong--inverted': Color.rgb([79, 79, 79]).toString(),
  /**
   * surface--muted--inverted
   * ------------------------
   * Default surface color for screens (pages) and UI background.
   */
  'surface--muted--inverted': Color.rgb([24, 25, 31]).toString(),
  /**
   * surface--medium--inverted
   * -------------------------
   * Alternative surface color for sreens (pages) and UI background. Also used forstriped tables.
   */
  'surface--medium--inverted': Color.rgb([36, 37, 45]).toString(),
  /**
   * surface--strong--inverted
   * -------------------------
   * Accent surface color for screens (pages) and UI background. Used tohelp cards and islands on-top stand out more.
   */
  'surface--strong--inverted': Color.rgb([48, 50, 60]).toString(),
  /**
   * surface--misc-transparent--inverted
   * -----------------------------------
   * Transparent surface token.
   */
  'surface--misc-transparent--inverted': Color.rgb([0, 0, 0]).alpha(0).toString(),
  /**
   * surface--misc-backdrop--inverted
   * --------------------------------
   * Surface color for backdrops behind modal windows.
   */
  'surface--misc-backdrop--inverted': Color.rgb([71, 71, 71]).alpha(0.3).toString(),
  /**
   * surface--misc-canvas--inverted
   * ------------------------------
   * Surface color for canvases, interactive boards, pipelines, document editors.
   */
  'surface--misc-canvas--inverted': Color.rgb([48, 50, 60]).toString(),
  /**
   * surface--misc-code--muted--inverted
   * -----------------------------------
   * Surface color for code editors and code examples (snippets)
   */
  'surface--misc-code--muted--inverted': Color.rgb([56, 55, 61]).toString(),
  /**
   * surface--misc-code--medium--inverted
   * ------------------------------------
   * Surface color for decorative elements of code editors and code examples (snippets)
   */
  'surface--misc-code--medium--inverted': Color.rgb([67, 65, 72]).toString(),
  /**
   * surface--interactive--hover--inverted
   * -------------------------------------
   * Generic hover state surface color for interactive elements without any specified background (e.g. table rows).
   */
  'surface--interactive--hover--inverted': Color.rgb([255, 255, 255]).alpha(0.06).toString(),
  /**
   * surface--interactive--pressed--inverted
   * ---------------------------------------
   * Generic pressed state surface color for interactive elements without any specified background (e.g. table rows).
   */
  'surface--interactive--pressed--inverted': Color.rgb([255, 255, 255]).alpha(0.1).toString(),
  /**
   * surface--interactive--toggled-default--inverted
   * -----------------------------------------------
   * Toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'surface--interactive--toggled-default--inverted': Color.rgb([109, 170, 255]).alpha(0.3).toString(),
  /**
   * surface--interactive--toggled-hover--inverted
   * ---------------------------------------------
   * Hover state of a toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'surface--interactive--toggled-hover--inverted': Color.rgb([109, 170, 255]).alpha(0.34).toString(),
  /**
   * surface--interactive--toggled-pressed--inverted
   * -----------------------------------------------
   * Pressed state of a toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'surface--interactive--toggled-pressed--inverted': Color.rgb([109, 170, 255]).alpha(0.42).toString(),
  /**
   * surface--interactive--disabled--inverted
   * ----------------------------------------
   * Disabled state surface color for interactive elements (e.g. buttons, inputs).
   */
  'surface--interactive--disabled--inverted': Color.rgb([255, 255, 255]).alpha(0.08).toString(),
  /**
   * surface--interactive--disabled--alt--inverted
   * ---------------------------------------------
   * Alternative disabled state surface color for duo-toned components (e.g. checkbox)
   */
  'surface--interactive--disabled--alt--inverted': Color.rgb([255, 255, 255]).alpha(0.24).toString(),
  /**
   * surface--action--strong--default--inverted
   * ------------------------------------------
   * Surface color for primary actions (e.g. primary button).
   */
  'surface--action--strong--default--inverted': Color.rgb([255, 255, 255]).toString(),
  /**
   * surface--action--strong--hover--inverted
   * ----------------------------------------
   * Hover state surface color for primary actions (e.g. primary button).
   */
  'surface--action--strong--hover--inverted': Color.rgb([232, 232, 232]).toString(),
  /**
   * surface--action--strong--pressed--inverted
   * ------------------------------------------
   * Pressed state surface color for primary actions (e.g. primary button).
   */
  'surface--action--strong--pressed--inverted': Color.rgb([218, 218, 218]).toString(),
  /**
   * surface--action--muted--default--inverted
   * -----------------------------------------
   * Surface color for secondary actions components (e.g. secondary button).
   */
  'surface--action--muted--default--inverted': Color.rgb([255, 255, 255]).alpha(0.1).toString(),
  /**
   * surface--action--muted--default--alt--inverted
   * ----------------------------------------------
   * Alternative surface color for smaller secondary actions components (e.g. switch).
   */
  'surface--action--muted--default--alt--inverted': Color.rgb([255, 255, 255]).alpha(0.32).toString(),
  /**
   * surface--action--muted--hover--inverted
   * ---------------------------------------
   * Hover state surface color for secondary actions (e.g. secondary button).
   */
  'surface--action--muted--hover--inverted': Color.rgb([255, 255, 255]).alpha(0.14).toString(),
  /**
   * surface--action--muted--pressed--inverted
   * -----------------------------------------
   * Pressed state surface color for secondary actions (e.g. secondary button).
   */
  'surface--action--muted--pressed--inverted': Color.rgb([255, 255, 255]).alpha(0.18).toString(),
  /**
   * surface--on--action--muted--default--inverted
   * ---------------------------------------------
   * Default state surface color to be used on top of secondary actions (e.g. segmented control).
   */
  'surface--on--action--muted--default--inverted': Color.rgb([255, 255, 255]).alpha(0.33).toString(),
  /**
   * surface--on--action--muted--hover--inverted
   * -------------------------------------------
   * Hover state surface color to be used on top of secondary actions (e.g. segmented control).
   */
  'surface--on--action--muted--hover--inverted': Color.rgb([255, 255, 255]).alpha(0.28).toString(),
  /**
   * surface--status-neutral--muted--default--inverted
   * -------------------------------------------------
   * Default (muted) surface color for neutral status. Used for smaller elements like label.
   */
  'surface--status-neutral--muted--default--inverted': Color.rgb([25, 31, 56]).toString(),
  /**
   * surface--status-neutral--muted--default--alt--inverted
   * ------------------------------------------------------
   * Alternative muted surface color for neutral status. Used for bigger elements like infobox.
   */
  'surface--status-neutral--muted--default--alt--inverted': Color.rgb([25, 31, 56]).toString(),
  /**
   * surface--status-neutral--muted--hover--inverted
   * -----------------------------------------------
   * Hover state of a muted surface color for neutral status.
   */
  'surface--status-neutral--muted--hover--inverted': Color.rgb([27, 37, 78]).toString(),
  /**
   * surface--status-neutral--muted--pressed--inverted
   * -------------------------------------------------
   * Pressed state of a muted surface color for neutral status.
   */
  'surface--status-neutral--muted--pressed--inverted': Color.rgb([28, 42, 98]).toString(),
  /**
   * surface--status-neutral--strong--default--inverted
   * --------------------------------------------------
   * Strong (saturated) surface color for neutral status.
   */
  'surface--status-neutral--strong--default--inverted': Color.rgb([77, 138, 255]).toString(),
  /**
   * surface--status-neutral--strong--hover--inverted
   * ------------------------------------------------
   * Hover state of a strong (saturated) surface color for neutral status.
   */
  'surface--status-neutral--strong--hover--inverted': Color.rgb([109, 170, 255]).toString(),
  /**
   * surface--status-neutral--strong--pressed--inverted
   * --------------------------------------------------
   * Pressed state of a strong (saturated) surface color for neutral status.
   */
  'surface--status-neutral--strong--pressed--inverted': Color.rgb([165, 200, 255]).toString(),
  /**
   * surface--status-success--muted--default--inverted
   * -------------------------------------------------
   * Default (muted) surface color for success status. Used for smaller elements like label.
   */
  'surface--status-success--muted--default--inverted': Color.rgb([23, 35, 35]).toString(),
  /**
   * surface--status-success--muted--default--alt--inverted
   * ------------------------------------------------------
   * Alternative muted surface color for success status. Used for bigger elements like infobox.
   */
  'surface--status-success--muted--default--alt--inverted': Color.rgb([23, 35, 35]).toString(),
  /**
   * surface--status-success--muted--hover--inverted
   * -----------------------------------------------
   * Hover state of a muted surface color for success status.
   */
  'surface--status-success--muted--hover--inverted': Color.rgb([22, 44, 39]).toString(),
  /**
   * surface--status-success--muted--pressed--inverted
   * -------------------------------------------------
   * Pressed state of a muted surface color for success status.
   */
  'surface--status-success--muted--pressed--inverted': Color.rgb([21, 53, 42]).toString(),
  /**
   * surface--status-success--strong--default--inverted
   * --------------------------------------------------
   * Strong (saturated) surface color for success status.
   */
  'surface--status-success--strong--default--inverted': Color.rgb([36, 162, 103]).toString(),
  /**
   * surface--status-success--strong--hover--inverted
   * ------------------------------------------------
   * Hover state of a strong (saturated) surface color for success status.
   */
  'surface--status-success--strong--hover--inverted': Color.rgb([44, 191, 122]).toString(),
  /**
   * surface--status-success--strong--pressed--inverted
   * --------------------------------------------------
   * Pressed state of a strong (saturated) surface color for success status.
   */
  'surface--status-success--strong--pressed--inverted': Color.rgb([119, 218, 163]).toString(),
  /**
   * surface--status-warning--muted--default--inverted
   * -------------------------------------------------
   * Default (muted) surface color for warning status. Used for smaller elements like label.
   */
  'surface--status-warning--muted--default--inverted': Color.rgb([52, 38, 26]).toString(),
  /**
   * surface--status-warning--muted--default--alt--inverted
   * ------------------------------------------------------
   * Alternative muted surface color for warning status. Used for bigger elements like infobox.
   */
  'surface--status-warning--muted--default--alt--inverted': Color.rgb([52, 38, 26]).toString(),
  /**
   * surface--status-warning--muted--hover--inverted
   * -----------------------------------------------
   * Hover state of a muted surface color for warning status.
   */
  'surface--status-warning--muted--hover--inverted': Color.rgb([76, 50, 22]).toString(),
  /**
   * surface--status-warning--muted--pressed--inverted
   * -------------------------------------------------
   * Pressed state of a muted surface color for warning status.
   */
  'surface--status-warning--muted--pressed--inverted': Color.rgb([98, 61, 19]).toString(),
  /**
   * surface--status-warning--strong--default--inverted
   * --------------------------------------------------
   * Strong (saturated) surface color for warning status.
   */
  'surface--status-warning--strong--default--inverted': Color.rgb([255, 187, 0]).toString(),
  /**
   * surface--status-warning--strong--hover--inverted
   * ------------------------------------------------
   * Hover state of a strong (saturated) surface color for warning status.
   */
  'surface--status-warning--strong--hover--inverted': Color.rgb([255, 201, 51]).toString(),
  /**
   * surface--status-warning--strong--pressed--inverted
   * --------------------------------------------------
   * Pressed state of a strong (saturated) surface color for warning status.
   */
  'surface--status-warning--strong--pressed--inverted': Color.rgb([255, 220, 127]).toString(),
  /**
   * surface--status-critical--muted--default--inverted
   * --------------------------------------------------
   * Default (muted) surface color for critical status. Used for smaller elements like label.
   */
  'surface--status-critical--muted--default--inverted': Color.rgb([45, 24, 31]).toString(),
  /**
   * surface--status-critical--muted--default--alt--inverted
   * -------------------------------------------------------
   * Alternative muted surface color for critical status. Used for bigger elements like infobox.
   */
  'surface--status-critical--muted--default--alt--inverted': Color.rgb([63, 22, 31]).toString(),
  /**
   * surface--status-critical--muted--hover--inverted
   * ------------------------------------------------
   * Hover state of a muted surface color for critical status.
   */
  'surface--status-critical--muted--hover--inverted': Color.rgb([45, 24, 31]).toString(),
  /**
   * surface--status-critical--muted--pressed--inverted
   * --------------------------------------------------
   * Pressed state of a muted surface color for critical status.
   */
  'surface--status-critical--muted--pressed--inverted': Color.rgb([80, 21, 31]).toString(),
  /**
   * surface--status-critical--strong--default--inverted
   * ---------------------------------------------------
   * Strong (saturated) surface color for critical status.
   */
  'surface--status-critical--strong--default--inverted': Color.rgb([250, 77, 86]).toString(),
  /**
   * surface--status-critical--strong--hover--inverted
   * -------------------------------------------------
   * Hover state of a strong (saturated) surface color for critical status.
   */
  'surface--status-critical--strong--hover--inverted': Color.rgb([251, 134, 138]).toString(),
  /**
   * surface--status-critical--strong--pressed--inverted
   * ---------------------------------------------------
   * Pressed state of a strong (saturated) surface color for critical status.
   */
  'surface--status-critical--strong--pressed--inverted': Color.rgb([252, 180, 182]).toString(),
  /**
   * surface--status-undefined--muted--default--inverted
   * ---------------------------------------------------
   * Default (muted) surface color for undefined status. Used for smaller elements like label.
   */
  'surface--status-undefined--muted--default--inverted': Color.rgb([33, 34, 40]).toString(),
  /**
   * surface--status-undefined--muted--default--alt--inverted
   * --------------------------------------------------------
   * Alternative muted surface color for undefined status. Used for bigger elements like infobox.
   */
  'surface--status-undefined--muted--default--alt--inverted': Color.rgb([33, 34, 40]).toString(),
  /**
   * surface--status-undefined--muted--hover--inverted
   * -------------------------------------------------
   * Hover state of a muted surface color for undefined status.
   */
  'surface--status-undefined--muted--hover--inverted': Color.rgb([40, 41, 47]).toString(),
  /**
   * surface--status-undefined--muted--pressed--inverted
   * ---------------------------------------------------
   * Pressed state of a muted surface color for undefined status.
   */
  'surface--status-undefined--muted--pressed--inverted': Color.rgb([47, 48, 54]).toString(),
  /**
   * surface--status-undefined--strong--default--inverted
   * ----------------------------------------------------
   * Strong (saturated) surface color for undefined status.
   */
  'surface--status-undefined--strong--default--inverted': Color.rgb([142, 142, 145]).toString(),
  /**
   * surface--status-undefined--strong--hover--inverted
   * --------------------------------------------------
   * Hover state of a strong (saturated) surface color for undefined status.
   */
  'surface--status-undefined--strong--hover--inverted': Color.rgb([168, 168, 168]).toString(),
  /**
   * surface--status-undefined--strong--pressed--inverted
   * ----------------------------------------------------
   * Pressed state of a strong (saturated) surface color for undefined status.
   */
  'surface--status-undefined--strong--pressed--inverted': Color.rgb([198, 198, 198]).toString(),
  /**
   * decorative--sapphire--50
   * ------------------------
   *
   */
  'decorative--sapphire--50': Color.rgb([237, 244, 255]).toString(),
  /**
   * decorative--sapphire--100
   * -------------------------
   *
   */
  'decorative--sapphire--100': Color.rgb([206, 225, 254]).toString(),
  /**
   * decorative--sapphire--200
   * -------------------------
   *
   */
  'decorative--sapphire--200': Color.rgb([165, 200, 255]).toString(),
  /**
   * decorative--sapphire--300
   * -------------------------
   *
   */
  'decorative--sapphire--300': Color.rgb([109, 170, 255]).toString(),
  /**
   * decorative--sapphire--400
   * -------------------------
   *
   */
  'decorative--sapphire--400': Color.rgb([77, 138, 255]).toString(),
  /**
   * decorative--sapphire--500
   * -------------------------
   *
   */
  'decorative--sapphire--500': Color.rgb([60, 95, 251]).toString(),
  /**
   * decorative--sapphire--600
   * -------------------------
   *
   */
  'decorative--sapphire--600': Color.rgb([33, 68, 199]).toString(),
  /**
   * decorative--sapphire--700
   * -------------------------
   *
   */
  'decorative--sapphire--700': Color.rgb([6, 44, 151]).toString(),
  /**
   * decorative--sapphire--800
   * -------------------------
   *
   */
  'decorative--sapphire--800': Color.rgb([3, 28, 106]).toString(),
  /**
   * decorative--sapphire--900
   * -------------------------
   *
   */
  'decorative--sapphire--900': Color.rgb([1, 15, 69]).toString(),
  /**
   * decorative--turquoise--50
   * -------------------------
   *
   */
  'decorative--turquoise--50': Color.rgb([217, 251, 251]).toString(),
  /**
   * decorative--turquoise--100
   * --------------------------
   *
   */
  'decorative--turquoise--100': Color.rgb([187, 235, 235]).toString(),
  /**
   * decorative--turquoise--200
   * --------------------------
   *
   */
  'decorative--turquoise--200': Color.rgb([106, 215, 214]).toString(),
  /**
   * decorative--turquoise--300
   * --------------------------
   *
   */
  'decorative--turquoise--300': Color.rgb([57, 187, 184]).toString(),
  /**
   * decorative--turquoise--400
   * --------------------------
   *
   */
  'decorative--turquoise--400': Color.rgb([27, 157, 159]).toString(),
  /**
   * decorative--turquoise--500
   * --------------------------
   *
   */
  'decorative--turquoise--500': Color.rgb([0, 125, 124]).toString(),
  /**
   * decorative--turquoise--600
   * --------------------------
   *
   */
  'decorative--turquoise--600': Color.rgb([0, 93, 90]).toString(),
  /**
   * decorative--turquoise--700
   * --------------------------
   *
   */
  'decorative--turquoise--700': Color.rgb([0, 65, 68]).toString(),
  /**
   * decorative--turquoise--800
   * --------------------------
   *
   */
  'decorative--turquoise--800': Color.rgb([2, 43, 48]).toString(),
  /**
   * decorative--turquoise--900
   * --------------------------
   *
   */
  'decorative--turquoise--900': Color.rgb([8, 26, 28]).toString(),
  /**
   * decorative--amethyst--50
   * ------------------------
   *
   */
  'decorative--amethyst--50': Color.rgb([246, 242, 255]).toString(),
  /**
   * decorative--amethyst--100
   * -------------------------
   *
   */
  'decorative--amethyst--100': Color.rgb([232, 218, 255]).toString(),
  /**
   * decorative--amethyst--200
   * -------------------------
   *
   */
  'decorative--amethyst--200': Color.rgb([212, 187, 255]).toString(),
  /**
   * decorative--amethyst--300
   * -------------------------
   *
   */
  'decorative--amethyst--300': Color.rgb([190, 149, 255]).toString(),
  /**
   * decorative--amethyst--400
   * -------------------------
   *
   */
  'decorative--amethyst--400': Color.rgb([165, 110, 255]).toString(),
  /**
   * decorative--amethyst--500
   * -------------------------
   *
   */
  'decorative--amethyst--500': Color.rgb([131, 81, 223]).toString(),
  /**
   * decorative--amethyst--600
   * -------------------------
   *
   */
  'decorative--amethyst--600': Color.rgb([105, 41, 196]).toString(),
  /**
   * decorative--amethyst--700
   * -------------------------
   *
   */
  'decorative--amethyst--700': Color.rgb([73, 29, 139]).toString(),
  /**
   * decorative--amethyst--800
   * -------------------------
   *
   */
  'decorative--amethyst--800': Color.rgb([49, 19, 94]).toString(),
  /**
   * decorative--amethyst--900
   * -------------------------
   *
   */
  'decorative--amethyst--900': Color.rgb([28, 15, 48]).toString(),
  /**
   * decorative--aquamarine--50
   * --------------------------
   *
   */
  'decorative--aquamarine--50': Color.rgb([229, 246, 255]).toString(),
  /**
   * decorative--aquamarine--100
   * ---------------------------
   *
   */
  'decorative--aquamarine--100': Color.rgb([186, 230, 255]).toString(),
  /**
   * decorative--aquamarine--200
   * ---------------------------
   *
   */
  'decorative--aquamarine--200': Color.rgb([130, 207, 255]).toString(),
  /**
   * decorative--aquamarine--300
   * ---------------------------
   *
   */
  'decorative--aquamarine--300': Color.rgb([51, 177, 255]).toString(),
  /**
   * decorative--aquamarine--400
   * ---------------------------
   *
   */
  'decorative--aquamarine--400': Color.rgb([17, 146, 232]).toString(),
  /**
   * decorative--aquamarine--500
   * ---------------------------
   *
   */
  'decorative--aquamarine--500': Color.rgb([0, 114, 195]).toString(),
  /**
   * decorative--aquamarine--600
   * ---------------------------
   *
   */
  'decorative--aquamarine--600': Color.rgb([0, 83, 154]).toString(),
  /**
   * decorative--aquamarine--700
   * ---------------------------
   *
   */
  'decorative--aquamarine--700': Color.rgb([0, 58, 109]).toString(),
  /**
   * decorative--aquamarine--800
   * ---------------------------
   *
   */
  'decorative--aquamarine--800': Color.rgb([1, 39, 73]).toString(),
  /**
   * decorative--aquamarine--900
   * ---------------------------
   *
   */
  'decorative--aquamarine--900': Color.rgb([6, 23, 39]).toString(),
  /**
   * decorative--emerald--50
   * -----------------------
   *
   */
  'decorative--emerald--50': Color.rgb([218, 252, 230]).toString(),
  /**
   * decorative--emerald--100
   * ------------------------
   *
   */
  'decorative--emerald--100': Color.rgb([174, 237, 198]).toString(),
  /**
   * decorative--emerald--200
   * ------------------------
   *
   */
  'decorative--emerald--200': Color.rgb([119, 218, 163]).toString(),
  /**
   * decorative--emerald--300
   * ------------------------
   *
   */
  'decorative--emerald--300': Color.rgb([44, 191, 122]).toString(),
  /**
   * decorative--emerald--400
   * ------------------------
   *
   */
  'decorative--emerald--400': Color.rgb([36, 162, 103]).toString(),
  /**
   * decorative--emerald--500
   * ------------------------
   *
   */
  'decorative--emerald--500': Color.rgb([0, 128, 77]).toString(),
  /**
   * decorative--emerald--600
   * ------------------------
   *
   */
  'decorative--emerald--600': Color.rgb([17, 94, 58]).toString(),
  /**
   * decorative--emerald--700
   * ------------------------
   *
   */
  'decorative--emerald--700': Color.rgb([9, 66, 39]).toString(),
  /**
   * decorative--emerald--800
   * ------------------------
   *
   */
  'decorative--emerald--800': Color.rgb([4, 44, 25]).toString(),
  /**
   * decorative--emerald--900
   * ------------------------
   *
   */
  'decorative--emerald--900': Color.rgb([2, 26, 13]).toString(),
  /**
   * decorative--canary--50
   * ----------------------
   *
   */
  'decorative--canary--50': Color.rgb([255, 243, 213]).toString(),
  /**
   * decorative--canary--100
   * -----------------------
   *
   */
  'decorative--canary--100': Color.rgb([255, 237, 171]).toString(),
  /**
   * decorative--canary--200
   * -----------------------
   *
   */
  'decorative--canary--200': Color.rgb([255, 220, 127]).toString(),
  /**
   * decorative--canary--300
   * -----------------------
   *
   */
  'decorative--canary--300': Color.rgb([255, 201, 51]).toString(),
  /**
   * decorative--canary--400
   * -----------------------
   *
   */
  'decorative--canary--400': Color.rgb([255, 187, 0]).toString(),
  /**
   * decorative--canary--500
   * -----------------------
   *
   */
  'decorative--canary--500': Color.rgb([235, 155, 0]).toString(),
  /**
   * decorative--canary--600
   * -----------------------
   *
   */
  'decorative--canary--600': Color.rgb([210, 114, 0]).toString(),
  /**
   * decorative--canary--700
   * -----------------------
   *
   */
  'decorative--canary--700': Color.rgb([170, 91, 0]).toString(),
  /**
   * decorative--canary--800
   * -----------------------
   *
   */
  'decorative--canary--800': Color.rgb([110, 57, 0]).toString(),
  /**
   * decorative--canary--900
   * -----------------------
   *
   */
  'decorative--canary--900': Color.rgb([74, 36, 0]).toString(),
  /**
   * decorative--amber--50
   * ---------------------
   *
   */
  'decorative--amber--50': Color.rgb([253, 241, 239]).toString(),
  /**
   * decorative--amber--100
   * ----------------------
   *
   */
  'decorative--amber--100': Color.rgb([255, 215, 207]).toString(),
  /**
   * decorative--amber--200
   * ----------------------
   *
   */
  'decorative--amber--200': Color.rgb([253, 181, 165]).toString(),
  /**
   * decorative--amber--300
   * ----------------------
   *
   */
  'decorative--amber--300': Color.rgb([245, 140, 108]).toString(),
  /**
   * decorative--amber--400
   * ----------------------
   *
   */
  'decorative--amber--400': Color.rgb([231, 101, 34]).toString(),
  /**
   * decorative--amber--500
   * ----------------------
   *
   */
  'decorative--amber--500': Color.rgb([188, 77, 0]).toString(),
  /**
   * decorative--amber--600
   * ----------------------
   *
   */
  'decorative--amber--600': Color.rgb([141, 56, 0]).toString(),
  /**
   * decorative--amber--700
   * ----------------------
   *
   */
  'decorative--amber--700': Color.rgb([101, 38, 0]).toString(),
  /**
   * decorative--amber--800
   * ----------------------
   *
   */
  'decorative--amber--800': Color.rgb([69, 23, 0]).toString(),
  /**
   * decorative--amber--900
   * ----------------------
   *
   */
  'decorative--amber--900': Color.rgb([43, 12, 0]).toString(),
  /**
   * decorative--ruby--50
   * --------------------
   *
   */
  'decorative--ruby--50': Color.rgb([254, 240, 241]).toString(),
  /**
   * decorative--ruby--100
   * ---------------------
   *
   */
  'decorative--ruby--100': Color.rgb([253, 214, 215]).toString(),
  /**
   * decorative--ruby--200
   * ---------------------
   *
   */
  'decorative--ruby--200': Color.rgb([252, 180, 182]).toString(),
  /**
   * decorative--ruby--300
   * ---------------------
   *
   */
  'decorative--ruby--300': Color.rgb([251, 134, 138]).toString(),
  /**
   * decorative--ruby--400
   * ---------------------
   *
   */
  'decorative--ruby--400': Color.rgb([250, 77, 86]).toString(),
  /**
   * decorative--ruby--500
   * ---------------------
   *
   */
  'decorative--ruby--500': Color.rgb([213, 41, 54]).toString(),
  /**
   * decorative--ruby--600
   * ---------------------
   *
   */
  'decorative--ruby--600': Color.rgb([165, 15, 30]).toString(),
  /**
   * decorative--ruby--700
   * ---------------------
   *
   */
  'decorative--ruby--700': Color.rgb([120, 2, 15]).toString(),
  /**
   * decorative--ruby--800
   * ---------------------
   *
   */
  'decorative--ruby--800': Color.rgb([82, 4, 10]).toString(),
  /**
   * decorative--ruby--900
   * ---------------------
   *
   */
  'decorative--ruby--900': Color.rgb([52, 1, 4]).toString(),
  /**
   * decorative--onyx--white
   * -----------------------
   *
   */
  'decorative--onyx--white': Color.rgb([255, 255, 255]).toString(),
  /**
   * decorative--onyx--50
   * --------------------
   *
   */
  'decorative--onyx--50': Color.rgb([243, 243, 243]).toString(),
  /**
   * decorative--onyx--100
   * ---------------------
   *
   */
  'decorative--onyx--100': Color.rgb([223, 223, 223]).toString(),
  /**
   * decorative--onyx--200
   * ---------------------
   *
   */
  'decorative--onyx--200': Color.rgb([198, 198, 198]).toString(),
  /**
   * decorative--onyx--300
   * ---------------------
   *
   */
  'decorative--onyx--300': Color.rgb([168, 168, 168]).toString(),
  /**
   * decorative--onyx--400
   * ---------------------
   *
   */
  'decorative--onyx--400': Color.rgb([142, 142, 145]).toString(),
  /**
   * decorative--onyx--500
   * ---------------------
   *
   */
  'decorative--onyx--500': Color.rgb([111, 111, 115]).toString(),
  /**
   * decorative--onyx--600
   * ---------------------
   *
   */
  'decorative--onyx--600': Color.rgb([81, 82, 89]).toString(),
  /**
   * decorative--onyx--700
   * ---------------------
   *
   */
  'decorative--onyx--700': Color.rgb([56, 57, 62]).toString(),
  /**
   * decorative--onyx--800
   * ---------------------
   *
   */
  'decorative--onyx--800': Color.rgb([37, 37, 42]).toString(),
  /**
   * decorative--onyx--900
   * ---------------------
   *
   */
  'decorative--onyx--900': Color.rgb([20, 21, 27]).toString(),
  /**
   * decorative--onyx--black
   * -----------------------
   *
   */
  'decorative--onyx--black': Color.rgb([0, 0, 0]).toString()
};
({
  /**
   * v11-text-icon--strong
   * ---------------------
   * Text and icon color for main body- and header text.
   */
  'v11-text-icon--strong': Color.rgb([0, 0, 0]).alpha(0.9).toString(),
  /**
   * v11-text-icon--medium
   * ---------------------
   * Text and icon color for secondary text, comments, etc.
   */
  'v11-text-icon--medium': Color.rgb([0, 0, 0]).alpha(0.7).toString(),
  /**
   * v11-text-icon--muted
   * --------------------
   * Text and icon color for hints or inputs placeholders.
   */
  'v11-text-icon--muted': Color.rgb([0, 0, 0]).alpha(0.55).toString(),
  /**
   * v11-text-icon--on-contrast--strong
   * ----------------------------------
   * Text and icon color to be used on high-contrast surfaces (action-strong and all status-[]-strong colors).
   */
  'v11-text-icon--on-contrast--strong': Color.rgb([255, 255, 255]).toString(),
  /**
   * v11-text-icon--interactive--default
   * -----------------------------------
   * Text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'v11-text-icon--interactive--default': Color.rgb([60, 95, 251]).toString(),
  /**
   * v11-text-icon--interactive--hover
   * ---------------------------------
   * Hover state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'v11-text-icon--interactive--hover': Color.rgb([33, 68, 199]).toString(),
  /**
   * v11-text-icon--interactive--pressed
   * -----------------------------------
   * Pressed state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'v11-text-icon--interactive--pressed': Color.rgb([6, 44, 151]).toString(),
  /**
   * v11-text-icon--interactive--disabled
   * ------------------------------------
   * Disabled state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'v11-text-icon--interactive--disabled': Color.rgb([140, 140, 140]).toString(),
  /**
   * v11-text-icon--status-neutral
   * -----------------------------
   * Text and icon color for neutral status, or to highlight information.
   */
  'v11-text-icon--status-neutral': Color.rgb([60, 95, 251]).toString(),
  /**
   * v11-text-icon--status-success
   * -----------------------------
   * Text and icon color for positive status, success, health.
   */
  'v11-text-icon--status-success': Color.rgb([0, 128, 77]).toString(),
  /**
   * v11-text-icon--status-warning
   * -----------------------------
   * Text and icon color for warnings, minor issues, minor errors.
   */
  'v11-text-icon--status-warning': Color.rgb([170, 91, 0]).toString(),
  /**
   * v11-text-icon--status-critical
   * ------------------------------
   * Text and icon color for critical information or major issues, danger, destructive action or major error.
   */
  'v11-text-icon--status-critical': Color.rgb([213, 41, 54]).toString(),
  /**
   * v11-text-icon--status-undefined
   * -------------------------------
   * Text and icon color for undefined state, default, unknown status, no-status.
   */
  'v11-text-icon--status-undefined': Color.rgb([111, 111, 115]).toString(),
  /**
   * v11-border--muted
   * -----------------
   * Default border color for screen dividers and generic non-interactive borders.
   */
  'v11-border--muted': Color.rgb([227, 228, 235]).toString(),
  /**
   * v11-border--interactive--default
   * --------------------------------
   * Border color for outlined components or controls (e.g. input, select, card).
   */
  'v11-border--interactive--default': Color.rgb([83, 88, 127]).alpha(0.16).toString(),
  /**
   * v11-border--interactive--default--alt
   * -------------------------------------
   * Alternative border color for small outlined components or controls (e.g. checkbox).
   */
  'v11-border--interactive--default--alt': Color.rgb([83, 88, 127]).alpha(0.24).toString(),
  /**
   * v11-border--interactive--hover
   * ------------------------------
   * Hover state border color for outlined components or controls.
   */
  'v11-border--interactive--hover': Color.rgb([85, 89, 104]).toString(),
  /**
   * v11-border--interactive--toggled-default
   * ----------------------------------------
   * Toggled (active, selected) state border color for outlined components or controls.
   */
  'v11-border--interactive--toggled-default': Color.rgb([24, 25, 31]).toString(),
  /**
   * v11-border--interactive--toggled-hover
   * --------------------------------------
   * Hover state of a toggled (active, selected) state border color for outlined components or controls.
   */
  'v11-border--interactive--toggled-hover': Color.rgb([42, 44, 52]).toString(),
  /**
   * v11-border--interactive--toggled-pressed
   * ----------------------------------------
   * Pressed state of a toggled (active, selected) state border color for outlined components or controls.
   */
  'v11-border--interactive--toggled-pressed': Color.rgb([63, 66, 78]).toString(),
  /**
   * v11-border--interactive--disabled
   * ---------------------------------
   * Disabled border color for interactive elements (e.g. checkboxes, selection control, inputs).
   */
  'v11-border--interactive--disabled': Color.rgb([0, 0, 0]).alpha(0.06).toString(),
  /**
   * v11-border--status-neutral--muted
   * ---------------------------------
   * Default (muted) border color for neutral status.
   */
  'v11-border--status-neutral--muted': Color.rgb([206, 225, 254]).toString(),
  /**
   * v11-border--status-neutral--strong
   * ----------------------------------
   * Strong (saturated) border color for neutral status.
   */
  'v11-border--status-neutral--strong': Color.rgb([60, 95, 251]).toString(),
  /**
   * v11-border--status-success--muted
   * ---------------------------------
   * Default (muted) border color for success status.
   */
  'v11-border--status-success--muted': Color.rgb([174, 237, 198]).toString(),
  /**
   * v11-border--status-success--strong
   * ----------------------------------
   * Strong (saturated) border color for success status.
   */
  'v11-border--status-success--strong': Color.rgb([0, 128, 77]).toString(),
  /**
   * v11-border--status-warning--muted
   * ---------------------------------
   * Default (muted) border color for warning status.
   */
  'v11-border--status-warning--muted': Color.rgb([255, 237, 171]).toString(),
  /**
   * v11-border--status-warning--strong
   * ----------------------------------
   * Strong (saturated) border color for warning status.
   */
  'v11-border--status-warning--strong': Color.rgb([235, 155, 0]).toString(),
  /**
   * v11-border--status-critical--muted
   * ----------------------------------
   * Default (muted) border color for critical status.
   */
  'v11-border--status-critical--muted': Color.rgb([253, 214, 215]).toString(),
  /**
   * v11-border--status-critical--strong
   * -----------------------------------
   * Strong (saturated) border color for critical status.
   */
  'v11-border--status-critical--strong': Color.rgb([213, 41, 54]).toString(),
  /**
   * v11-border--status-undefined--muted
   * -----------------------------------
   * Default (muted) border color for undefined status.
   */
  'v11-border--status-undefined--muted': Color.rgb([223, 223, 223]).toString(),
  /**
   * v11-border--status-undefined--strong
   * ------------------------------------
   * Strong (saturated) border color for undefined status.
   */
  'v11-border--status-undefined--strong': Color.rgb([111, 111, 115]).toString(),
  /**
   * v11-surface--muted
   * ------------------
   * Default surface color for screens (pages) and UI background.
   */
  'v11-surface--muted': Color.rgb([255, 255, 255]).toString(),
  /**
   * v11-surface--medium
   * -------------------
   * Alternative surface color for sreens (pages) and UI background. Also used forstriped tables.
   */
  'v11-surface--medium': Color.rgb([250, 250, 250]).toString(),
  /**
   * v11-surface--strong
   * -------------------
   * Accent surface color for screens (pages) and UI background. Used tohelp cards and islands on-top stand out more.
   */
  'v11-surface--strong': Color.rgb([245, 245, 245]).toString(),
  /**
   * v11-surface--misc-transparent
   * -----------------------------
   * Transparent surface token.
   */
  'v11-surface--misc-transparent': Color.rgb([255, 255, 255]).alpha(0).toString(),
  /**
   * v11-surface--misc-backdrop
   * --------------------------
   * Surface color for backdrops behind modal windows.
   */
  'v11-surface--misc-backdrop': Color.rgb([71, 71, 71]).alpha(0.4).toString(),
  /**
   * v11-surface--misc-canvas
   * ------------------------
   * Surface color for canvases, interactive boards, pipelines, document editors.
   */
  'v11-surface--misc-canvas': Color.rgb([245, 245, 245]).toString(),
  /**
   * v11-surface--misc-code--muted
   * -----------------------------
   * Surface color for code editors and code examples (snippets)
   */
  'v11-surface--misc-code--muted': Color.rgb([50, 56, 83]).alpha(0.04).toString(),
  /**
   * v11-surface--misc-code--medium
   * ------------------------------
   * Surface color for decorative elements of code editors and code examples (snippets)
   */
  'v11-surface--misc-code--medium': Color.rgb([50, 56, 83]).alpha(0.06).toString(),
  /**
   * v11-surface--interactive--hover
   * -------------------------------
   * Generic hover state surface color for interactive elements without any specified background (e.g. table rows).
   */
  'v11-surface--interactive--hover': Color.rgb([24, 25, 31]).alpha(0.06).toString(),
  /**
   * v11-surface--interactive--pressed
   * ---------------------------------
   * Generic pressed state surface color for interactive elements without any specified background (e.g. table rows).
   */
  'v11-surface--interactive--pressed': Color.rgb([24, 25, 31]).alpha(0.1).toString(),
  /**
   * v11-surface--interactive--toggled-default
   * -----------------------------------------
   * Toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'v11-surface--interactive--toggled-default': Color.rgb([52, 128, 247]).alpha(0.16).toString(),
  /**
   * v11-surface--interactive--toggled-hover
   * ---------------------------------------
   * Hover state of a toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'v11-surface--interactive--toggled-hover': Color.rgb([52, 128, 247]).alpha(0.2).toString(),
  /**
   * v11-surface--interactive--toggled-pressed
   * -----------------------------------------
   * Pressed state of a toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'v11-surface--interactive--toggled-pressed': Color.rgb([52, 128, 247]).alpha(0.24).toString(),
  /**
   * v11-surface--interactive--disabled
   * ----------------------------------
   * Disabled state surface color for interactive elements (e.g. buttons, inputs).
   */
  'v11-surface--interactive--disabled': Color.rgb([0, 0, 0]).alpha(0.03).toString(),
  /**
   * v11-surface--interactive--disabled--alt
   * ---------------------------------------
   * Alternative disabled state surface color for duo-toned components (e.g. checkbox)
   */
  'v11-surface--interactive--disabled--alt': Color.rgb([0, 0, 0]).alpha(0.16).toString(),
  /**
   * v11-surface--action--strong--default
   * ------------------------------------
   * Surface color for primary actions (e.g. primary button).
   */
  'v11-surface--action--strong--default': Color.rgb([24, 25, 31]).toString(),
  /**
   * v11-surface--action--strong--hover
   * ----------------------------------
   * Hover state surface color for primary actions (e.g. primary button).
   */
  'v11-surface--action--strong--hover': Color.rgb([63, 66, 78]).toString(),
  /**
   * v11-surface--action--strong--pressed
   * ------------------------------------
   * Pressed state surface color for primary actions (e.g. primary button).
   */
  'v11-surface--action--strong--pressed': Color.rgb([79, 82, 96]).toString(),
  /**
   * v11-surface--action--muted--default
   * -----------------------------------
   * Surface color for secondary actions components (e.g. secondary button).
   */
  'v11-surface--action--muted--default': Color.rgb([88, 91, 107]).alpha(0.08).toString(),
  /**
   * v11-surface--action--muted--default--alt
   * ----------------------------------------
   * Alternative surface color for smaller secondary actions components (e.g. switch).
   */
  'v11-surface--action--muted--default--alt': Color.rgb([88, 91, 107]).alpha(0.24).toString(),
  /**
   * v11-surface--action--muted--hover
   * ---------------------------------
   * Hover state surface color for secondary actions (e.g. secondary button).
   */
  'v11-surface--action--muted--hover': Color.rgb([88, 91, 107]).alpha(0.12).toString(),
  /**
   * v11-surface--action--muted--pressed
   * -----------------------------------
   * Pressed state surface color for secondary actions (e.g. secondary button).
   */
  'v11-surface--action--muted--pressed': Color.rgb([88, 91, 107]).alpha(0.16).toString(),
  /**
   * v11-surface--on--action--muted--default
   * ---------------------------------------
   * Default state surface color to be used on top of secondary actions (e.g. segmented control).
   */
  'v11-surface--on--action--muted--default': Color.rgb([255, 255, 255]).toString(),
  /**
   * v11-surface--on--action--muted--hover
   * -------------------------------------
   * Hover state surface color to be used on top of secondary actions (e.g. segmented control).
   */
  'v11-surface--on--action--muted--hover': Color.rgb([255, 255, 255]).alpha(0.5).toString(),
  /**
   * v11-surface--status-neutral--muted--default
   * -------------------------------------------
   * Default (muted) surface color for neutral status. Used for smaller elements like label.
   */
  'v11-surface--status-neutral--muted--default': Color.rgb([237, 244, 255]).toString(),
  /**
   * v11-surface--status-neutral--muted--default--alt
   * ------------------------------------------------
   * Alternative muted surface color for neutral status. Used for bigger elements like infobox.
   */
  'v11-surface--status-neutral--muted--default--alt': Color.rgb([237, 244, 255]).toString(),
  /**
   * v11-surface--status-neutral--muted--hover
   * -----------------------------------------
   * Hover state of a muted surface color for neutral status.
   */
  'v11-surface--status-neutral--muted--hover': Color.rgb([206, 225, 254]).toString(),
  /**
   * v11-surface--status-neutral--muted--pressed
   * -------------------------------------------
   * Pressed state of a muted surface color for neutral status.
   */
  'v11-surface--status-neutral--muted--pressed': Color.rgb([165, 200, 255]).toString(),
  /**
   * v11-surface--status-neutral--strong--default
   * --------------------------------------------
   * Strong (saturated) surface color for neutral status.
   */
  'v11-surface--status-neutral--strong--default': Color.rgb([60, 95, 251]).toString(),
  /**
   * v11-surface--status-neutral--strong--hover
   * ------------------------------------------
   * Hover state of a strong (saturated) surface color for neutral status.
   */
  'v11-surface--status-neutral--strong--hover': Color.rgb([33, 68, 199]).toString(),
  /**
   * v11-surface--status-neutral--strong--pressed
   * --------------------------------------------
   * Pressed state of a strong (saturated) surface color for neutral status.
   */
  'v11-surface--status-neutral--strong--pressed': Color.rgb([6, 44, 151]).toString(),
  /**
   * v11-surface--status-success--muted--default
   * -------------------------------------------
   * Default (muted) surface color for success status. Used for smaller elements like label.
   */
  'v11-surface--status-success--muted--default': Color.rgb([218, 252, 230]).toString(),
  /**
   * v11-surface--status-success--muted--default--alt
   * ------------------------------------------------
   * Alternative muted surface color for success status. Used for bigger elements like infobox.
   */
  'v11-surface--status-success--muted--default--alt': Color.rgb([218, 252, 230]).toString(),
  /**
   * v11-surface--status-success--muted--hover
   * -----------------------------------------
   * Hover state of a muted surface color for success status.
   */
  'v11-surface--status-success--muted--hover': Color.rgb([174, 237, 198]).toString(),
  /**
   * v11-surface--status-success--muted--pressed
   * -------------------------------------------
   * Pressed state of a muted surface color for success status.
   */
  'v11-surface--status-success--muted--pressed': Color.rgb([119, 218, 163]).toString(),
  /**
   * v11-surface--status-success--strong--default
   * --------------------------------------------
   * Strong (saturated) surface color for success status.
   */
  'v11-surface--status-success--strong--default': Color.rgb([0, 128, 77]).toString(),
  /**
   * v11-surface--status-success--strong--hover
   * ------------------------------------------
   * Hover state of a strong (saturated) surface color for success status.
   */
  'v11-surface--status-success--strong--hover': Color.rgb([17, 94, 58]).toString(),
  /**
   * v11-surface--status-success--strong--pressed
   * --------------------------------------------
   * Pressed state of a strong (saturated) surface color for success status.
   */
  'v11-surface--status-success--strong--pressed': Color.rgb([9, 66, 39]).toString(),
  /**
   * v11-surface--status-warning--muted--default
   * -------------------------------------------
   * Default (muted) surface color for warning status. Used for smaller elements like label.
   */
  'v11-surface--status-warning--muted--default': Color.rgb([255, 243, 213]).toString(),
  /**
   * v11-surface--status-warning--muted--default--alt
   * ------------------------------------------------
   * Alternative muted surface color for warning status. Used for bigger elements like infobox.
   */
  'v11-surface--status-warning--muted--default--alt': Color.rgb([255, 243, 213]).toString(),
  /**
   * v11-surface--status-warning--muted--hover
   * -----------------------------------------
   * Hover state of a muted surface color for warning status.
   */
  'v11-surface--status-warning--muted--hover': Color.rgb([255, 237, 171]).toString(),
  /**
   * v11-surface--status-warning--muted--pressed
   * -------------------------------------------
   * Pressed state of a muted surface color for warning status.
   */
  'v11-surface--status-warning--muted--pressed': Color.rgb([255, 220, 127]).toString(),
  /**
   * v11-surface--status-warning--strong--default
   * --------------------------------------------
   * Strong (saturated) surface color for warning status.
   */
  'v11-surface--status-warning--strong--default': Color.rgb([235, 155, 0]).toString(),
  /**
   * v11-surface--status-warning--strong--hover
   * ------------------------------------------
   * Hover state of a strong (saturated) surface color for warning status.
   */
  'v11-surface--status-warning--strong--hover': Color.rgb([210, 114, 0]).toString(),
  /**
   * v11-surface--status-warning--strong--pressed
   * --------------------------------------------
   * Pressed state of a strong (saturated) surface color for warning status.
   */
  'v11-surface--status-warning--strong--pressed': Color.rgb([170, 91, 0]).toString(),
  /**
   * v11-surface--status-critical--muted--default
   * --------------------------------------------
   * Default (muted) surface color for critical status. Used for smaller elements like label.
   */
  'v11-surface--status-critical--muted--default': Color.rgb([254, 240, 241]).toString(),
  /**
   * v11-surface--status-critical--muted--default--alt
   * -------------------------------------------------
   * Alternative muted surface color for critical status. Used for bigger elements like infobox.
   */
  'v11-surface--status-critical--muted--default--alt': Color.rgb([254, 240, 241]).toString(),
  /**
   * v11-surface--status-critical--muted--hover
   * ------------------------------------------
   * Hover state of a muted surface color for critical status.
   */
  'v11-surface--status-critical--muted--hover': Color.rgb([253, 214, 215]).toString(),
  /**
   * v11-surface--status-critical--muted--pressed
   * --------------------------------------------
   * Pressed state of a muted surface color for critical status.
   */
  'v11-surface--status-critical--muted--pressed': Color.rgb([252, 180, 182]).toString(),
  /**
   * v11-surface--status-critical--strong--default
   * ---------------------------------------------
   * Strong (saturated) surface color for critical status.
   */
  'v11-surface--status-critical--strong--default': Color.rgb([213, 41, 54]).toString(),
  /**
   * v11-surface--status-critical--strong--hover
   * -------------------------------------------
   * Hover state of a strong (saturated) surface color for critical status.
   */
  'v11-surface--status-critical--strong--hover': Color.rgb([165, 15, 30]).toString(),
  /**
   * v11-surface--status-critical--strong--pressed
   * ---------------------------------------------
   * Pressed state of a strong (saturated) surface color for critical status.
   */
  'v11-surface--status-critical--strong--pressed': Color.rgb([120, 2, 15]).toString(),
  /**
   * v11-surface--status-undefined--muted--default
   * ---------------------------------------------
   * Default (muted) surface color for undefined status. Used for smaller elements like label.
   */
  'v11-surface--status-undefined--muted--default': Color.rgb([243, 243, 243]).toString(),
  /**
   * v11-surface--status-undefined--muted--default--alt
   * --------------------------------------------------
   * Alternative muted surface color for undefined status. Used for bigger elements like infobox.
   */
  'v11-surface--status-undefined--muted--default--alt': Color.rgb([243, 243, 243]).toString(),
  /**
   * v11-surface--status-undefined--muted--hover
   * -------------------------------------------
   * Hover state of a muted surface color for undefined status.
   */
  'v11-surface--status-undefined--muted--hover': Color.rgb([223, 223, 223]).toString(),
  /**
   * v11-surface--status-undefined--muted--pressed
   * ---------------------------------------------
   * Pressed state of a muted surface color for undefined status.
   */
  'v11-surface--status-undefined--muted--pressed': Color.rgb([198, 198, 198]).toString(),
  /**
   * v11-surface--status-undefined--strong--default
   * ----------------------------------------------
   * Strong (saturated) surface color for undefined status.
   */
  'v11-surface--status-undefined--strong--default': Color.rgb([111, 111, 115]).toString(),
  /**
   * v11-surface--status-undefined--strong--hover
   * --------------------------------------------
   * Hover state of a strong (saturated) surface color for undefined status.
   */
  'v11-surface--status-undefined--strong--hover': Color.rgb([81, 82, 89]).toString(),
  /**
   * v11-surface--status-undefined--strong--pressed
   * ----------------------------------------------
   * Pressed state of a strong (saturated) surface color for undefined status.
   */
  'v11-surface--status-undefined--strong--pressed': Color.rgb([56, 57, 62]).toString(),
  /**
   * v11-text-icon--strong--inverted
   * -------------------------------
   * Text and icon color for main body- and header text.
   */
  'v11-text-icon--strong--inverted': Color.rgb([255, 255, 255]).alpha(0.95).toString(),
  /**
   * v11-text-icon--medium--inverted
   * -------------------------------
   * Text and icon color for secondary text, comments, etc.
   */
  'v11-text-icon--medium--inverted': Color.rgb([255, 255, 255]).alpha(0.82).toString(),
  /**
   * v11-text-icon--muted--inverted
   * ------------------------------
   * Text and icon color for hints or inputs placeholders.
   */
  'v11-text-icon--muted--inverted': Color.rgb([255, 255, 255]).alpha(0.72).toString(),
  /**
   * v11-text-icon--on-contrast--strong--inverted
   * --------------------------------------------
   * Text and icon color to be used on high-contrast surfaces (action-strong and all status-[]-strong colors).
   */
  'v11-text-icon--on-contrast--strong--inverted': Color.rgb([38, 38, 38]).toString(),
  /**
   * v11-text-icon--interactive--default--inverted
   * ---------------------------------------------
   * Text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'v11-text-icon--interactive--default--inverted': Color.rgb([219, 225, 254]).toString(),
  /**
   * v11-text-icon--interactive--hover--inverted
   * -------------------------------------------
   * Hover state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'v11-text-icon--interactive--hover--inverted': Color.rgb([237, 240, 255]).toString(),
  /**
   * v11-text-icon--interactive--pressed--inverted
   * ---------------------------------------------
   * Pressed state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'v11-text-icon--interactive--pressed--inverted': Color.rgb([246, 247, 255]).toString(),
  /**
   * v11-text-icon--interactive--disabled--inverted
   * ----------------------------------------------
   * Disabled state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'v11-text-icon--interactive--disabled--inverted': Color.rgb([255, 255, 255]).alpha(0.4).toString(),
  /**
   * v11-text-icon--status-neutral--inverted
   * ---------------------------------------
   * Text and icon color for neutral status, or to highlight information.
   */
  'v11-text-icon--status-neutral--inverted': Color.rgb([188, 208, 250]).toString(),
  /**
   * v11-text-icon--status-success--inverted
   * ---------------------------------------
   * Text and icon color for positive status, success, health.
   */
  'v11-text-icon--status-success--inverted': Color.rgb([172, 219, 179]).toString(),
  /**
   * v11-text-icon--status-warning--inverted
   * ---------------------------------------
   * Text and icon color for warnings, minor issues, minor errors.
   */
  'v11-text-icon--status-warning--inverted': Color.rgb([252, 199, 98]).toString(),
  /**
   * v11-text-icon--status-critical--inverted
   * ----------------------------------------
   * Text and icon color for critical information or major issues, danger, destructive action or major error.
   */
  'v11-text-icon--status-critical--inverted': Color.rgb([249, 195, 184]).toString(),
  /**
   * v11-text-icon--status-undefined--inverted
   * -----------------------------------------
   * Text and icon color for undefined state, default, unknown status, no-status.
   */
  'v11-text-icon--status-undefined--inverted': Color.rgb([208, 208, 208]).toString(),
  /**
   * v11-border--muted--inverted
   * ---------------------------
   * Default border color for screen dividers and generic non-interactive borders.
   */
  'v11-border--muted--inverted': Color.rgb([81, 81, 81]).toString(),
  /**
   * v11-border--interactive--default--inverted
   * ------------------------------------------
   * Border color for outlined components or controls (e.g. input, select, card).
   */
  'v11-border--interactive--default--inverted': Color.rgb([255, 255, 255]).alpha(0.2).toString(),
  /**
   * v11-border--interactive--default--alt--inverted
   * -----------------------------------------------
   * Alternative border color for small outlined components or controls (e.g. checkbox).
   */
  'v11-border--interactive--default--alt--inverted': Color.rgb([255, 255, 255]).alpha(0.28).toString(),
  /**
   * v11-border--interactive--hover--inverted
   * ----------------------------------------
   * Hover state border color for outlined components or controls.
   */
  'v11-border--interactive--hover--inverted': Color.rgb([232, 232, 232]).toString(),
  /**
   * v11-border--interactive--toggled-default--inverted
   * --------------------------------------------------
   * Toggled (active, selected) state border color for outlined components or controls.
   */
  'v11-border--interactive--toggled-default--inverted': Color.rgb([255, 255, 255]).toString(),
  /**
   * v11-border--interactive--toggled-hover--inverted
   * ------------------------------------------------
   * Hover state of a toggled (active, selected) state border color for outlined components or controls.
   */
  'v11-border--interactive--toggled-hover--inverted': Color.rgb([232, 232, 232]).toString(),
  /**
   * v11-border--interactive--toggled-pressed--inverted
   * --------------------------------------------------
   * Pressed state of a toggled (active, selected) state border color for outlined components or controls.
   */
  'v11-border--interactive--toggled-pressed--inverted': Color.rgb([218, 218, 218]).toString(),
  /**
   * v11-border--interactive--disabled--inverted
   * -------------------------------------------
   * Disabled border color for interactive elements (e.g. checkboxes, selection control, inputs).
   */
  'v11-border--interactive--disabled--inverted': Color.rgb([255, 255, 255]).alpha(0.08).toString(),
  /**
   * v11-border--status-neutral--muted--inverted
   * -------------------------------------------
   * Default (muted) border color for neutral status.
   */
  'v11-border--status-neutral--muted--inverted': Color.rgb([64, 120, 240]).alpha(0.4).toString(),
  /**
   * v11-border--status-neutral--strong--inverted
   * --------------------------------------------
   * Strong (saturated) border color for neutral status.
   */
  'v11-border--status-neutral--strong--inverted': Color.rgb([64, 120, 240]).toString(),
  /**
   * v11-border--status-success--muted--inverted
   * -------------------------------------------
   * Default (muted) border color for success status.
   */
  'v11-border--status-success--muted--inverted': Color.rgb([74, 178, 91]).alpha(0.4).toString(),
  /**
   * v11-border--status-success--strong--inverted
   * --------------------------------------------
   * Strong (saturated) border color for success status.
   */
  'v11-border--status-success--strong--inverted': Color.rgb([74, 178, 91]).toString(),
  /**
   * v11-border--status-warning--muted--inverted
   * -------------------------------------------
   * Default (muted) border color for warning status.
   */
  'v11-border--status-warning--muted--inverted': Color.rgb([250, 174, 26]).alpha(0.4).toString(),
  /**
   * v11-border--status-warning--strong--inverted
   * --------------------------------------------
   * Strong (saturated) border color for warning status.
   */
  'v11-border--status-warning--strong--inverted': Color.rgb([250, 174, 26]).toString(),
  /**
   * v11-border--status-critical--muted--inverted
   * --------------------------------------------
   * Default (muted) border color for critical status.
   */
  'v11-border--status-critical--muted--inverted': Color.rgb([238, 76, 40]).alpha(0.4).toString(),
  /**
   * v11-border--status-critical--strong--inverted
   * ---------------------------------------------
   * Strong (saturated) border color for critical status.
   */
  'v11-border--status-critical--strong--inverted': Color.rgb([238, 76, 40]).toString(),
  /**
   * v11-border--status-undefined--muted--inverted
   * ---------------------------------------------
   * Default (muted) border color for undefined status.
   */
  'v11-border--status-undefined--muted--inverted': Color.rgb([79, 79, 79]).alpha(0.4).toString(),
  /**
   * v11-border--status-undefined--strong--inverted
   * ----------------------------------------------
   * Strong (saturated) border color for undefined status.
   */
  'v11-border--status-undefined--strong--inverted': Color.rgb([79, 79, 79]).toString(),
  /**
   * v11-surface--muted--inverted
   * ----------------------------
   * Default surface color for screens (pages) and UI background.
   */
  'v11-surface--muted--inverted': Color.rgb([24, 25, 31]).toString(),
  /**
   * v11-surface--medium--inverted
   * -----------------------------
   * Alternative surface color for sreens (pages) and UI background. Also used forstriped tables.
   */
  'v11-surface--medium--inverted': Color.rgb([36, 37, 45]).toString(),
  /**
   * v11-surface--strong--inverted
   * -----------------------------
   * Accent surface color for screens (pages) and UI background. Used tohelp cards and islands on-top stand out more.
   */
  'v11-surface--strong--inverted': Color.rgb([48, 50, 60]).toString(),
  /**
   * v11-surface--misc-transparent--inverted
   * ---------------------------------------
   * Transparent surface token.
   */
  'v11-surface--misc-transparent--inverted': Color.rgb([0, 0, 0]).alpha(0).toString(),
  /**
   * v11-surface--misc-backdrop--inverted
   * ------------------------------------
   * Surface color for backdrops behind modal windows.
   */
  'v11-surface--misc-backdrop--inverted': Color.rgb([71, 71, 71]).alpha(0.3).toString(),
  /**
   * v11-surface--misc-canvas--inverted
   * ----------------------------------
   * Surface color for canvases, interactive boards, pipelines, document editors.
   */
  'v11-surface--misc-canvas--inverted': Color.rgb([48, 50, 60]).toString(),
  /**
   * v11-surface--misc-code--muted--inverted
   * ---------------------------------------
   * Surface color for code editors and code examples (snippets)
   */
  'v11-surface--misc-code--muted--inverted': Color.rgb([56, 55, 61]).toString(),
  /**
   * v11-surface--misc-code--medium--inverted
   * ----------------------------------------
   * Surface color for decorative elements of code editors and code examples (snippets)
   */
  'v11-surface--misc-code--medium--inverted': Color.rgb([67, 65, 72]).toString(),
  /**
   * v11-surface--interactive--hover--inverted
   * -----------------------------------------
   * Generic hover state surface color for interactive elements without any specified background (e.g. table rows).
   */
  'v11-surface--interactive--hover--inverted': Color.rgb([255, 255, 255]).alpha(0.06).toString(),
  /**
   * v11-surface--interactive--pressed--inverted
   * -------------------------------------------
   * Generic pressed state surface color for interactive elements without any specified background (e.g. table rows).
   */
  'v11-surface--interactive--pressed--inverted': Color.rgb([255, 255, 255]).alpha(0.1).toString(),
  /**
   * v11-surface--interactive--toggled-default--inverted
   * ---------------------------------------------------
   * Toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'v11-surface--interactive--toggled-default--inverted': Color.rgb([109, 170, 255]).alpha(0.3).toString(),
  /**
   * v11-surface--interactive--toggled-hover--inverted
   * -------------------------------------------------
   * Hover state of a toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'v11-surface--interactive--toggled-hover--inverted': Color.rgb([109, 170, 255]).alpha(0.34).toString(),
  /**
   * v11-surface--interactive--toggled-pressed--inverted
   * ---------------------------------------------------
   * Pressed state of a toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'v11-surface--interactive--toggled-pressed--inverted': Color.rgb([109, 170, 255]).alpha(0.42).toString(),
  /**
   * v11-surface--interactive--disabled--inverted
   * --------------------------------------------
   * Disabled state surface color for interactive elements (e.g. buttons, inputs).
   */
  'v11-surface--interactive--disabled--inverted': Color.rgb([255, 255, 255]).alpha(0.08).toString(),
  /**
   * v11-surface--interactive--disabled--alt--inverted
   * -------------------------------------------------
   * Alternative disabled state surface color for duo-toned components (e.g. checkbox)
   */
  'v11-surface--interactive--disabled--alt--inverted': Color.rgb([255, 255, 255]).alpha(0.24).toString(),
  /**
   * v11-surface--action--strong--default--inverted
   * ----------------------------------------------
   * Surface color for primary actions (e.g. primary button).
   */
  'v11-surface--action--strong--default--inverted': Color.rgb([255, 255, 255]).toString(),
  /**
   * v11-surface--action--strong--hover--inverted
   * --------------------------------------------
   * Hover state surface color for primary actions (e.g. primary button).
   */
  'v11-surface--action--strong--hover--inverted': Color.rgb([232, 232, 232]).toString(),
  /**
   * v11-surface--action--strong--pressed--inverted
   * ----------------------------------------------
   * Pressed state surface color for primary actions (e.g. primary button).
   */
  'v11-surface--action--strong--pressed--inverted': Color.rgb([218, 218, 218]).toString(),
  /**
   * v11-surface--action--muted--default--inverted
   * ---------------------------------------------
   * Surface color for secondary actions components (e.g. secondary button).
   */
  'v11-surface--action--muted--default--inverted': Color.rgb([255, 255, 255]).alpha(0.1).toString(),
  /**
   * v11-surface--action--muted--default--alt--inverted
   * --------------------------------------------------
   * Alternative surface color for smaller secondary actions components (e.g. switch).
   */
  'v11-surface--action--muted--default--alt--inverted': Color.rgb([255, 255, 255]).alpha(0.32).toString(),
  /**
   * v11-surface--action--muted--hover--inverted
   * -------------------------------------------
   * Hover state surface color for secondary actions (e.g. secondary button).
   */
  'v11-surface--action--muted--hover--inverted': Color.rgb([255, 255, 255]).alpha(0.14).toString(),
  /**
   * v11-surface--action--muted--pressed--inverted
   * ---------------------------------------------
   * Pressed state surface color for secondary actions (e.g. secondary button).
   */
  'v11-surface--action--muted--pressed--inverted': Color.rgb([255, 255, 255]).alpha(0.18).toString(),
  /**
   * v11-surface--on--action--muted--default--inverted
   * -------------------------------------------------
   * Default state surface color to be used on top of secondary actions (e.g. segmented control).
   */
  'v11-surface--on--action--muted--default--inverted': Color.rgb([255, 255, 255]).alpha(0.33).toString(),
  /**
   * v11-surface--on--action--muted--hover--inverted
   * -----------------------------------------------
   * Hover state surface color to be used on top of secondary actions (e.g. segmented control).
   */
  'v11-surface--on--action--muted--hover--inverted': Color.rgb([255, 255, 255]).alpha(0.28).toString(),
  /**
   * v11-surface--status-neutral--muted--default--inverted
   * -----------------------------------------------------
   * Default (muted) surface color for neutral status. Used for smaller elements like label.
   */
  'v11-surface--status-neutral--muted--default--inverted': Color.rgb([25, 31, 56]).toString(),
  /**
   * v11-surface--status-neutral--muted--default--alt--inverted
   * ----------------------------------------------------------
   * Alternative muted surface color for neutral status. Used for bigger elements like infobox.
   */
  'v11-surface--status-neutral--muted--default--alt--inverted': Color.rgb([25, 31, 56]).toString(),
  /**
   * v11-surface--status-neutral--muted--hover--inverted
   * ---------------------------------------------------
   * Hover state of a muted surface color for neutral status.
   */
  'v11-surface--status-neutral--muted--hover--inverted': Color.rgb([27, 37, 78]).toString(),
  /**
   * v11-surface--status-neutral--muted--pressed--inverted
   * -----------------------------------------------------
   * Pressed state of a muted surface color for neutral status.
   */
  'v11-surface--status-neutral--muted--pressed--inverted': Color.rgb([28, 42, 98]).toString(),
  /**
   * v11-surface--status-neutral--strong--default--inverted
   * ------------------------------------------------------
   * Strong (saturated) surface color for neutral status.
   */
  'v11-surface--status-neutral--strong--default--inverted': Color.rgb([77, 138, 255]).toString(),
  /**
   * v11-surface--status-neutral--strong--hover--inverted
   * ----------------------------------------------------
   * Hover state of a strong (saturated) surface color for neutral status.
   */
  'v11-surface--status-neutral--strong--hover--inverted': Color.rgb([109, 170, 255]).toString(),
  /**
   * v11-surface--status-neutral--strong--pressed--inverted
   * ------------------------------------------------------
   * Pressed state of a strong (saturated) surface color for neutral status.
   */
  'v11-surface--status-neutral--strong--pressed--inverted': Color.rgb([165, 200, 255]).toString(),
  /**
   * v11-surface--status-success--muted--default--inverted
   * -----------------------------------------------------
   * Default (muted) surface color for success status. Used for smaller elements like label.
   */
  'v11-surface--status-success--muted--default--inverted': Color.rgb([23, 35, 35]).toString(),
  /**
   * v11-surface--status-success--muted--default--alt--inverted
   * ----------------------------------------------------------
   * Alternative muted surface color for success status. Used for bigger elements like infobox.
   */
  'v11-surface--status-success--muted--default--alt--inverted': Color.rgb([23, 35, 35]).toString(),
  /**
   * v11-surface--status-success--muted--hover--inverted
   * ---------------------------------------------------
   * Hover state of a muted surface color for success status.
   */
  'v11-surface--status-success--muted--hover--inverted': Color.rgb([22, 44, 39]).toString(),
  /**
   * v11-surface--status-success--muted--pressed--inverted
   * -----------------------------------------------------
   * Pressed state of a muted surface color for success status.
   */
  'v11-surface--status-success--muted--pressed--inverted': Color.rgb([21, 53, 42]).toString(),
  /**
   * v11-surface--status-success--strong--default--inverted
   * ------------------------------------------------------
   * Strong (saturated) surface color for success status.
   */
  'v11-surface--status-success--strong--default--inverted': Color.rgb([36, 162, 103]).toString(),
  /**
   * v11-surface--status-success--strong--hover--inverted
   * ----------------------------------------------------
   * Hover state of a strong (saturated) surface color for success status.
   */
  'v11-surface--status-success--strong--hover--inverted': Color.rgb([44, 191, 122]).toString(),
  /**
   * v11-surface--status-success--strong--pressed--inverted
   * ------------------------------------------------------
   * Pressed state of a strong (saturated) surface color for success status.
   */
  'v11-surface--status-success--strong--pressed--inverted': Color.rgb([119, 218, 163]).toString(),
  /**
   * v11-surface--status-warning--muted--default--inverted
   * -----------------------------------------------------
   * Default (muted) surface color for warning status. Used for smaller elements like label.
   */
  'v11-surface--status-warning--muted--default--inverted': Color.rgb([52, 38, 26]).toString(),
  /**
   * v11-surface--status-warning--muted--default--alt--inverted
   * ----------------------------------------------------------
   * Alternative muted surface color for warning status. Used for bigger elements like infobox.
   */
  'v11-surface--status-warning--muted--default--alt--inverted': Color.rgb([52, 38, 26]).toString(),
  /**
   * v11-surface--status-warning--muted--hover--inverted
   * ---------------------------------------------------
   * Hover state of a muted surface color for warning status.
   */
  'v11-surface--status-warning--muted--hover--inverted': Color.rgb([76, 50, 22]).toString(),
  /**
   * v11-surface--status-warning--muted--pressed--inverted
   * -----------------------------------------------------
   * Pressed state of a muted surface color for warning status.
   */
  'v11-surface--status-warning--muted--pressed--inverted': Color.rgb([98, 61, 19]).toString(),
  /**
   * v11-surface--status-warning--strong--default--inverted
   * ------------------------------------------------------
   * Strong (saturated) surface color for warning status.
   */
  'v11-surface--status-warning--strong--default--inverted': Color.rgb([255, 187, 0]).toString(),
  /**
   * v11-surface--status-warning--strong--hover--inverted
   * ----------------------------------------------------
   * Hover state of a strong (saturated) surface color for warning status.
   */
  'v11-surface--status-warning--strong--hover--inverted': Color.rgb([255, 201, 51]).toString(),
  /**
   * v11-surface--status-warning--strong--pressed--inverted
   * ------------------------------------------------------
   * Pressed state of a strong (saturated) surface color for warning status.
   */
  'v11-surface--status-warning--strong--pressed--inverted': Color.rgb([255, 220, 127]).toString(),
  /**
   * v11-surface--status-critical--muted--default--inverted
   * ------------------------------------------------------
   * Default (muted) surface color for critical status. Used for smaller elements like label.
   */
  'v11-surface--status-critical--muted--default--inverted': Color.rgb([45, 24, 31]).toString(),
  /**
   * v11-surface--status-critical--muted--default--alt--inverted
   * -----------------------------------------------------------
   * Alternative muted surface color for critical status. Used for bigger elements like infobox.
   */
  'v11-surface--status-critical--muted--default--alt--inverted': Color.rgb([63, 22, 31]).toString(),
  /**
   * v11-surface--status-critical--muted--hover--inverted
   * ----------------------------------------------------
   * Hover state of a muted surface color for critical status.
   */
  'v11-surface--status-critical--muted--hover--inverted': Color.rgb([45, 24, 31]).toString(),
  /**
   * v11-surface--status-critical--muted--pressed--inverted
   * ------------------------------------------------------
   * Pressed state of a muted surface color for critical status.
   */
  'v11-surface--status-critical--muted--pressed--inverted': Color.rgb([80, 21, 31]).toString(),
  /**
   * v11-surface--status-critical--strong--default--inverted
   * -------------------------------------------------------
   * Strong (saturated) surface color for critical status.
   */
  'v11-surface--status-critical--strong--default--inverted': Color.rgb([250, 77, 86]).toString(),
  /**
   * v11-surface--status-critical--strong--hover--inverted
   * -----------------------------------------------------
   * Hover state of a strong (saturated) surface color for critical status.
   */
  'v11-surface--status-critical--strong--hover--inverted': Color.rgb([251, 134, 138]).toString(),
  /**
   * v11-surface--status-critical--strong--pressed--inverted
   * -------------------------------------------------------
   * Pressed state of a strong (saturated) surface color for critical status.
   */
  'v11-surface--status-critical--strong--pressed--inverted': Color.rgb([252, 180, 182]).toString(),
  /**
   * v11-surface--status-undefined--muted--default--inverted
   * -------------------------------------------------------
   * Default (muted) surface color for undefined status. Used for smaller elements like label.
   */
  'v11-surface--status-undefined--muted--default--inverted': Color.rgb([33, 34, 40]).toString(),
  /**
   * v11-surface--status-undefined--muted--default--alt--inverted
   * ------------------------------------------------------------
   * Alternative muted surface color for undefined status. Used for bigger elements like infobox.
   */
  'v11-surface--status-undefined--muted--default--alt--inverted': Color.rgb([33, 34, 40]).toString(),
  /**
   * v11-surface--status-undefined--muted--hover--inverted
   * -----------------------------------------------------
   * Hover state of a muted surface color for undefined status.
   */
  'v11-surface--status-undefined--muted--hover--inverted': Color.rgb([40, 41, 47]).toString(),
  /**
   * v11-surface--status-undefined--muted--pressed--inverted
   * -------------------------------------------------------
   * Pressed state of a muted surface color for undefined status.
   */
  'v11-surface--status-undefined--muted--pressed--inverted': Color.rgb([47, 48, 54]).toString(),
  /**
   * v11-surface--status-undefined--strong--default--inverted
   * --------------------------------------------------------
   * Strong (saturated) surface color for undefined status.
   */
  'v11-surface--status-undefined--strong--default--inverted': Color.rgb([142, 142, 145]).toString(),
  /**
   * v11-surface--status-undefined--strong--hover--inverted
   * ------------------------------------------------------
   * Hover state of a strong (saturated) surface color for undefined status.
   */
  'v11-surface--status-undefined--strong--hover--inverted': Color.rgb([168, 168, 168]).toString(),
  /**
   * v11-surface--status-undefined--strong--pressed--inverted
   * --------------------------------------------------------
   * Pressed state of a strong (saturated) surface color for undefined status.
   */
  'v11-surface--status-undefined--strong--pressed--inverted': Color.rgb([198, 198, 198]).toString()
});
var aiTokens = {
  /**
   * ai-text-icon--strong
   * --------------------
   * Text and icon color for main body- and header text.
   */
  'ai-text-icon--strong': Color.rgb([0, 0, 0]).alpha(0.9).toString(),
  /**
   * ai-text-icon--medium
   * --------------------
   * Text and icon color for secondary text, comments, etc.
   */
  'ai-text-icon--medium': Color.rgb([0, 0, 0]).alpha(0.7).toString(),
  /**
   * ai-text-icon--muted
   * -------------------
   * Text and icon color for hints or inputs placeholders.
   */
  'ai-text-icon--muted': Color.rgb([0, 0, 0]).alpha(0.55).toString(),
  /**
   * ai-text-icon--on-contrast--strong
   * ---------------------------------
   * Text and icon color to be used on high-contrast surfaces (action-strong and all status-[]-strong colors).
   */
  'ai-text-icon--on-contrast--strong': Color.rgb([255, 255, 255]).toString(),
  /**
   * ai-text-icon--interactive--default
   * ----------------------------------
   * Text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'ai-text-icon--interactive--default': Color.rgb([96, 42, 207]).toString(),
  /**
   * ai-text-icon--interactive--hover
   * --------------------------------
   * Hover state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'ai-text-icon--interactive--hover': Color.rgb([83, 35, 180]).toString(),
  /**
   * ai-text-icon--interactive--pressed
   * ----------------------------------
   * Pressed state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'ai-text-icon--interactive--pressed': Color.rgb([70, 29, 155]).toString(),
  /**
   * ai-text-icon--interactive--disabled
   * -----------------------------------
   * Disabled state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'ai-text-icon--interactive--disabled': Color.rgb([140, 140, 140]).toString(),
  /**
   * ai-text-icon--status-neutral
   * ----------------------------
   * Text and icon color for neutral status, or to highlight information.
   */
  'ai-text-icon--status-neutral': Color.rgb([104, 64, 205]).toString(),
  /**
   * ai-text-icon--status-success
   * ----------------------------
   * Text and icon color for positive status, success, health.
   */
  'ai-text-icon--status-success': Color.rgb([44, 105, 53]).toString(),
  /**
   * ai-text-icon--status-warning
   * ----------------------------
   * Text and icon color for warnings, minor issues, minor errors.
   */
  'ai-text-icon--status-warning': Color.rgb([143, 76, 15]).toString(),
  /**
   * ai-text-icon--status-critical
   * -----------------------------
   * Text and icon color for critical information or major issues, danger, destructive action or major error.
   */
  'ai-text-icon--status-critical': Color.rgb([168, 54, 28]).toString(),
  /**
   * ai-text-icon--status-undefined
   * ------------------------------
   * Text and icon color for undefined state, default, unknown status, no-status.
   */
  'ai-text-icon--status-undefined': Color.rgb([93, 93, 93]).toString(),
  /**
   * ai-border--muted
   * ----------------
   * Default border color for screen dividers and generic non-interactive borders.
   */
  'ai-border--muted': Color.rgb([217, 217, 217]).toString(),
  /**
   * ai-border--interactive--default
   * -------------------------------
   * Border color for outlined components or controls (e.g. input, select, card).
   */
  'ai-border--interactive--default': Color.rgb([83, 88, 127]).alpha(0.16).toString(),
  /**
   * ai-border--interactive--default--alt
   * ------------------------------------
   * Alternative border color for small outlined components or controls (e.g. checkbox).
   */
  'ai-border--interactive--default--alt': Color.rgb([83, 88, 127]).alpha(0.24).toString(),
  /**
   * ai-border--interactive--hover
   * -----------------------------
   * Hover state border color for outlined components or controls.
   */
  'ai-border--interactive--hover': Color.rgb([141, 110, 237]).toString(),
  /**
   * ai-border--interactive--toggled-default
   * ---------------------------------------
   * Toggled (active, selected) state border color for outlined components or controls.
   */
  'ai-border--interactive--toggled-default': Color.rgb([111, 59, 228]).toString(),
  /**
   * ai-border--interactive--toggled-hover
   * -------------------------------------
   * Hover state of a toggled (active, selected) state border color for outlined components or controls.
   */
  'ai-border--interactive--toggled-hover': Color.rgb([99, 44, 212]).toString(),
  /**
   * ai-border--interactive--toggled-pressed
   * ---------------------------------------
   * Pressed state of a toggled (active, selected) state border color for outlined components or controls.
   */
  'ai-border--interactive--toggled-pressed': Color.rgb([86, 37, 186]).toString(),
  /**
   * ai-border--interactive--disabled
   * --------------------------------
   * Disabled border color for interactive elements (e.g. checkboxes, selection control, inputs).
   */
  'ai-border--interactive--disabled': Color.rgb([0, 0, 0]).alpha(0.06).toString(),
  /**
   * ai-border--status-neutral--muted
   * --------------------------------
   * Default (muted) border color for neutral status.
   */
  'ai-border--status-neutral--muted': Color.rgb([136, 102, 236]).alpha(0.2).toString(),
  /**
   * ai-border--status-neutral--strong
   * ---------------------------------
   * Strong (saturated) border color for neutral status.
   */
  'ai-border--status-neutral--strong': Color.rgb([136, 102, 236]).toString(),
  /**
   * ai-border--status-success--muted
   * --------------------------------
   * Default (muted) border color for success status.
   */
  'ai-border--status-success--muted': Color.rgb([57, 162, 99]).alpha(0.2).toString(),
  /**
   * ai-border--status-success--strong
   * ---------------------------------
   * Strong (saturated) border color for success status.
   */
  'ai-border--status-success--strong': Color.rgb([57, 162, 99]).toString(),
  /**
   * ai-border--status-warning--muted
   * --------------------------------
   * Default (muted) border color for warning status.
   */
  'ai-border--status-warning--muted': Color.rgb([255, 187, 0]).alpha(0.2).toString(),
  /**
   * ai-border--status-warning--strong
   * ---------------------------------
   * Strong (saturated) border color for warning status.
   */
  'ai-border--status-warning--strong': Color.rgb([235, 155, 0]).toString(),
  /**
   * ai-border--status-critical--muted
   * ---------------------------------
   * Default (muted) border color for critical status.
   */
  'ai-border--status-critical--muted': Color.rgb([223, 66, 55]).alpha(0.2).toString(),
  /**
   * ai-border--status-critical--strong
   * ----------------------------------
   * Strong (saturated) border color for critical status.
   */
  'ai-border--status-critical--strong': Color.rgb([229, 59, 56]).toString(),
  /**
   * ai-border--status-undefined--muted
   * ----------------------------------
   * Default (muted) border color for undefined status.
   */
  'ai-border--status-undefined--muted': Color.rgb([102, 102, 102]).alpha(0.2).toString(),
  /**
   * ai-border--status-undefined--strong
   * -----------------------------------
   * Strong (saturated) border color for undefined status.
   */
  'ai-border--status-undefined--strong': Color.rgb([102, 102, 102]).toString(),
  /**
   * ai-surface--muted
   * -----------------
   * Default surface color for screens (pages) and UI background.
   */
  'ai-surface--muted': Color.rgb([255, 255, 255]).toString(),
  /**
   * ai-surface--medium
   * ------------------
   * Alternative surface color for sreens (pages) and UI background. Also used forstriped tables.
   */
  'ai-surface--medium': Color.rgb([250, 250, 250]).toString(),
  /**
   * ai-surface--strong
   * ------------------
   * Accent surface color for screens (pages) and UI background. Used tohelp cards and islands on-top stand out more.
   */
  'ai-surface--strong': Color.rgb([245, 245, 245]).toString(),
  /**
   * ai-surface--misc-transparent
   * ----------------------------
   * Transparent surface token.
   */
  'ai-surface--misc-transparent': Color.rgb([255, 255, 255]).alpha(0).toString(),
  /**
   * ai-surface--misc-backdrop
   * -------------------------
   * Surface color for backdrops behind modal windows.
   */
  'ai-surface--misc-backdrop': Color.rgb([71, 71, 71]).alpha(0.4).toString(),
  /**
   * ai-surface--misc-canvas
   * -----------------------
   * Surface color for canvases, interactive boards, pipelines, document editors.
   */
  'ai-surface--misc-canvas': Color.rgb([245, 245, 245]).toString(),
  /**
   * ai-surface--misc-code--muted
   * ----------------------------
   * Surface color for code editors and code examples (snippets)
   */
  'ai-surface--misc-code--muted': Color.rgb([50, 56, 83]).alpha(0.04).toString(),
  /**
   * ai-surface--misc-code--medium
   * -----------------------------
   * Surface color for decorative elements of code editors and code examples (snippets)
   */
  'ai-surface--misc-code--medium': Color.rgb([50, 56, 83]).alpha(0.06).toString(),
  /**
   * ai-surface--interactive--hover
   * ------------------------------
   * Generic hover state surface color for interactive elements without any specified background (e.g. table rows).
   */
  'ai-surface--interactive--hover': Color.rgb([142, 92, 255]).alpha(0.1).toString(),
  /**
   * ai-surface--interactive--pressed
   * --------------------------------
   * Generic pressed state surface color for interactive elements without any specified background (e.g. table rows).
   */
  'ai-surface--interactive--pressed': Color.rgb([142, 92, 255]).alpha(0.14).toString(),
  /**
   * ai-surface--interactive--toggled-default
   * ----------------------------------------
   * Toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'ai-surface--interactive--toggled-default': Color.rgb([111, 59, 228]).alpha(0.08).toString(),
  /**
   * ai-surface--interactive--toggled-hover
   * --------------------------------------
   * Hover state of a toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'ai-surface--interactive--toggled-hover': Color.rgb([111, 59, 228]).alpha(0.12).toString(),
  /**
   * ai-surface--interactive--toggled-pressed
   * ----------------------------------------
   * Pressed state of a toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'ai-surface--interactive--toggled-pressed': Color.rgb([111, 59, 228]).alpha(0.18).toString(),
  /**
   * ai-surface--interactive--disabled
   * ---------------------------------
   * Disabled state surface color for interactive elements (e.g. buttons, inputs).
   */
  'ai-surface--interactive--disabled': Color.rgb([0, 0, 0]).alpha(0.03).toString(),
  /**
   * ai-surface--interactive--disabled--alt
   * --------------------------------------
   * Alternative disabled state surface color for duo-toned components (e.g. checkbox)
   */
  'ai-surface--interactive--disabled--alt': Color.rgb([0, 0, 0]).alpha(0.06).toString(),
  /**
   * ai-surface--action--strong--default
   * -----------------------------------
   * Surface color for primary actions (e.g. primary button).
   */
  'ai-surface--action--strong--default': Color.rgb([111, 59, 228]).toString(),
  /**
   * ai-surface--action--strong--hover
   * ---------------------------------
   * Hover state surface color for primary actions (e.g. primary button).
   */
  'ai-surface--action--strong--hover': Color.rgb([88, 39, 191]).toString(),
  /**
   * ai-surface--action--strong--pressed
   * -----------------------------------
   * Pressed state surface color for primary actions (e.g. primary button).
   */
  'ai-surface--action--strong--pressed': Color.rgb([74, 31, 163]).toString(),
  /**
   * ai-surface--action--muted--default
   * ----------------------------------
   * Surface color for secondary actions components (e.g. secondary button).
   */
  'ai-surface--action--muted--default': Color.rgb([83, 88, 127]).alpha(0.08).toString(),
  /**
   * ai-surface--action--muted--default--alt
   * ---------------------------------------
   * Alternative surface color for smaller secondary actions components (e.g. switch).
   */
  'ai-surface--action--muted--default--alt': Color.rgb([83, 88, 127]).alpha(0.24).toString(),
  /**
   * ai-surface--action--muted--hover
   * --------------------------------
   * Hover state surface color for secondary actions (e.g. secondary button).
   */
  'ai-surface--action--muted--hover': Color.rgb([83, 88, 127]).alpha(0.12).toString(),
  /**
   * ai-surface--action--muted--pressed
   * ----------------------------------
   * Pressed state surface color for secondary actions (e.g. secondary button).
   */
  'ai-surface--action--muted--pressed': Color.rgb([83, 88, 127]).alpha(0.16).toString(),
  /**
   * ai-surface--on--action--muted--default
   * --------------------------------------
   * Default state surface color to be used on top of secondary actions (e.g. segmented control).
   */
  'ai-surface--on--action--muted--default': Color.rgb([255, 255, 255]).toString(),
  /**
   * ai-surface--on--action--muted--hover
   * ------------------------------------
   * Hover state surface color to be used on top of secondary actions (e.g. segmented control).
   */
  'ai-surface--on--action--muted--hover': Color.rgb([255, 255, 255]).alpha(0.5).toString(),
  /**
   * ai-surface--status-neutral--muted--default
   * ------------------------------------------
   * Default (muted) surface color for neutral status. Used for smaller elements like label.
   */
  'ai-surface--status-neutral--muted--default': Color.rgb([111, 59, 228]).alpha(0.07).toString(),
  /**
   * ai-surface--status-neutral--muted--default--alt
   * -----------------------------------------------
   * Alternative muted surface color for neutral status. Used for bigger elements like infobox.
   */
  'ai-surface--status-neutral--muted--default--alt': Color.rgb([111, 59, 228]).alpha(0.04).toString(),
  /**
   * ai-surface--status-neutral--muted--hover
   * ----------------------------------------
   * Hover state of a muted surface color for neutral status.
   */
  'ai-surface--status-neutral--muted--hover': Color.rgb([111, 59, 228]).alpha(0.12).toString(),
  /**
   * ai-surface--status-neutral--muted--pressed
   * ------------------------------------------
   * Pressed state of a muted surface color for neutral status.
   */
  'ai-surface--status-neutral--muted--pressed': Color.rgb([111, 59, 228]).alpha(0.16).toString(),
  /**
   * ai-surface--status-neutral--strong--default
   * -------------------------------------------
   * Strong (saturated) surface color for neutral status.
   */
  'ai-surface--status-neutral--strong--default': Color.rgb([111, 59, 228]).toString(),
  /**
   * ai-surface--status-neutral--strong--hover
   * -----------------------------------------
   * Hover state of a strong (saturated) surface color for neutral status.
   */
  'ai-surface--status-neutral--strong--hover': Color.rgb([99, 44, 212]).toString(),
  /**
   * ai-surface--status-neutral--strong--pressed
   * -------------------------------------------
   * Pressed state of a strong (saturated) surface color for neutral status.
   */
  'ai-surface--status-neutral--strong--pressed': Color.rgb([86, 37, 186]).toString(),
  /**
   * ai-surface--status-success--muted--default
   * ------------------------------------------
   * Default (muted) surface color for success status. Used for smaller elements like label.
   */
  'ai-surface--status-success--muted--default': Color.rgb([57, 162, 99]).alpha(0.1).toString(),
  /**
   * ai-surface--status-success--muted--default--alt
   * -----------------------------------------------
   * Alternative muted surface color for success status. Used for bigger elements like infobox.
   */
  'ai-surface--status-success--muted--default--alt': Color.rgb([57, 162, 99]).alpha(0.06).toString(),
  /**
   * ai-surface--status-success--muted--hover
   * ----------------------------------------
   * Hover state of a muted surface color for success status.
   */
  'ai-surface--status-success--muted--hover': Color.rgb([57, 162, 99]).alpha(0.15).toString(),
  /**
   * ai-surface--status-success--muted--pressed
   * ------------------------------------------
   * Pressed state of a muted surface color for success status.
   */
  'ai-surface--status-success--muted--pressed': Color.rgb([57, 162, 99]).alpha(0.18).toString(),
  /**
   * ai-surface--status-success--strong--default
   * -------------------------------------------
   * Strong (saturated) surface color for success status.
   */
  'ai-surface--status-success--strong--default': Color.rgb([44, 133, 79]).toString(),
  /**
   * ai-surface--status-success--strong--hover
   * -----------------------------------------
   * Hover state of a strong (saturated) surface color for success status.
   */
  'ai-surface--status-success--strong--hover': Color.rgb([39, 117, 70]).toString(),
  /**
   * ai-surface--status-success--strong--pressed
   * -------------------------------------------
   * Pressed state of a strong (saturated) surface color for success status.
   */
  'ai-surface--status-success--strong--pressed': Color.rgb([33, 102, 61]).toString(),
  /**
   * ai-surface--status-warning--muted--default
   * ------------------------------------------
   * Default (muted) surface color for warning status. Used for smaller elements like label.
   */
  'ai-surface--status-warning--muted--default': Color.rgb([255, 187, 0]).alpha(0.12).toString(),
  /**
   * ai-surface--status-warning--muted--default--alt
   * -----------------------------------------------
   * Alternative muted surface color for warning status. Used for bigger elements like infobox.
   */
  'ai-surface--status-warning--muted--default--alt': Color.rgb([255, 187, 0]).alpha(0.06).toString(),
  /**
   * ai-surface--status-warning--muted--hover
   * ----------------------------------------
   * Hover state of a muted surface color for warning status.
   */
  'ai-surface--status-warning--muted--hover': Color.rgb([255, 187, 0]).alpha(0.15).toString(),
  /**
   * ai-surface--status-warning--muted--pressed
   * ------------------------------------------
   * Pressed state of a muted surface color for warning status.
   */
  'ai-surface--status-warning--muted--pressed': Color.rgb([255, 187, 0]).alpha(0.2).toString(),
  /**
   * ai-surface--status-warning--strong--default
   * -------------------------------------------
   * Strong (saturated) surface color for warning status.
   */
  'ai-surface--status-warning--strong--default': Color.rgb([186, 93, 0]).toString(),
  /**
   * ai-surface--status-warning--strong--hover
   * -----------------------------------------
   * Hover state of a strong (saturated) surface color for warning status.
   */
  'ai-surface--status-warning--strong--hover': Color.rgb([176, 88, 0]).toString(),
  /**
   * ai-surface--status-warning--strong--pressed
   * -------------------------------------------
   * Pressed state of a strong (saturated) surface color for warning status.
   */
  'ai-surface--status-warning--strong--pressed': Color.rgb([166, 77, 0]).toString(),
  /**
   * ai-surface--status-critical--muted--default
   * -------------------------------------------
   * Default (muted) surface color for critical status. Used for smaller elements like label.
   */
  'ai-surface--status-critical--muted--default': Color.rgb([223, 64, 55]).alpha(0.08).toString(),
  /**
   * ai-surface--status-critical--muted--default--alt
   * ------------------------------------------------
   * Alternative muted surface color for critical status. Used for bigger elements like infobox.
   */
  'ai-surface--status-critical--muted--default--alt': Color.rgb([223, 64, 55]).alpha(0.06).toString(),
  /**
   * ai-surface--status-critical--muted--hover
   * -----------------------------------------
   * Hover state of a muted surface color for critical status.
   */
  'ai-surface--status-critical--muted--hover': Color.rgb([223, 63, 55]).alpha(0.12).toString(),
  /**
   * ai-surface--status-critical--muted--pressed
   * -------------------------------------------
   * Pressed state of a muted surface color for critical status.
   */
  'ai-surface--status-critical--muted--pressed': Color.rgb([223, 64, 55]).alpha(0.16).toString(),
  /**
   * ai-surface--status-critical--strong--default
   * --------------------------------------------
   * Strong (saturated) surface color for critical status.
   */
  'ai-surface--status-critical--strong--default': Color.rgb([189, 36, 28]).toString(),
  /**
   * ai-surface--status-critical--strong--hover
   * ------------------------------------------
   * Hover state of a strong (saturated) surface color for critical status.
   */
  'ai-surface--status-critical--strong--hover': Color.rgb([173, 33, 26]).toString(),
  /**
   * ai-surface--status-critical--strong--pressed
   * --------------------------------------------
   * Pressed state of a strong (saturated) surface color for critical status.
   */
  'ai-surface--status-critical--strong--pressed': Color.rgb([158, 30, 24]).toString(),
  /**
   * ai-surface--status-undefined--muted--default
   * --------------------------------------------
   * Default (muted) surface color for undefined status. Used for smaller elements like label.
   */
  'ai-surface--status-undefined--muted--default': Color.rgb([102, 102, 102]).alpha(0.1).toString(),
  /**
   * ai-surface--status-undefined--muted--default--alt
   * -------------------------------------------------
   * Alternative muted surface color for undefined status. Used for bigger elements like infobox.
   */
  'ai-surface--status-undefined--muted--default--alt': Color.rgb([102, 102, 102]).alpha(0.06).toString(),
  /**
   * ai-surface--status-undefined--muted--hover
   * ------------------------------------------
   * Hover state of a muted surface color for undefined status.
   */
  'ai-surface--status-undefined--muted--hover': Color.rgb([102, 102, 102]).alpha(0.14).toString(),
  /**
   * ai-surface--status-undefined--muted--pressed
   * --------------------------------------------
   * Pressed state of a muted surface color for undefined status.
   */
  'ai-surface--status-undefined--muted--pressed': Color.rgb([102, 102, 102]).alpha(0.2).toString(),
  /**
   * ai-surface--status-undefined--strong--default
   * ---------------------------------------------
   * Strong (saturated) surface color for undefined status.
   */
  'ai-surface--status-undefined--strong--default': Color.rgb([117, 117, 117]).toString(),
  /**
   * ai-surface--status-undefined--strong--hover
   * -------------------------------------------
   * Hover state of a strong (saturated) surface color for undefined status.
   */
  'ai-surface--status-undefined--strong--hover': Color.rgb([102, 102, 102]).toString(),
  /**
   * ai-surface--status-undefined--strong--pressed
   * ---------------------------------------------
   * Pressed state of a strong (saturated) surface color for undefined status.
   */
  'ai-surface--status-undefined--strong--pressed': Color.rgb([77, 77, 77]).toString(),
  /**
   * ai-text-icon--strong--inverted
   * ------------------------------
   * Text and icon color for main body- and header text.
   */
  'ai-text-icon--strong--inverted': Color.rgb([255, 255, 255]).alpha(0.95).toString(),
  /**
   * ai-text-icon--medium--inverted
   * ------------------------------
   * Text and icon color for secondary text, comments, etc.
   */
  'ai-text-icon--medium--inverted': Color.rgb([255, 255, 255]).alpha(0.82).toString(),
  /**
   * ai-text-icon--muted--inverted
   * -----------------------------
   * Text and icon color for hints or inputs placeholders.
   */
  'ai-text-icon--muted--inverted': Color.rgb([255, 255, 255]).alpha(0.72).toString(),
  /**
   * ai-text-icon--on-contrast--strong--inverted
   * -------------------------------------------
   * Text and icon color to be used on high-contrast surfaces (action-strong and all status-[]-strong colors).
   */
  'ai-text-icon--on-contrast--strong--inverted': Color.rgb([38, 38, 38]).toString(),
  /**
   * ai-text-icon--interactive--default--inverted
   * --------------------------------------------
   * Text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'ai-text-icon--interactive--default--inverted': Color.rgb([225, 220, 251]).toString(),
  /**
   * ai-text-icon--interactive--hover--inverted
   * ------------------------------------------
   * Hover state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'ai-text-icon--interactive--hover--inverted': Color.rgb([241, 239, 253]).toString(),
  /**
   * ai-text-icon--interactive--pressed--inverted
   * --------------------------------------------
   * Pressed state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'ai-text-icon--interactive--pressed--inverted': Color.rgb([247, 245, 254]).toString(),
  /**
   * ai-text-icon--interactive--disabled--inverted
   * ---------------------------------------------
   * Disabled state text and icon color for links and texts in interactive components (accent button or toggled button).
   */
  'ai-text-icon--interactive--disabled--inverted': Color.rgb([255, 255, 255]).alpha(0.4).toString(),
  /**
   * ai-text-icon--status-neutral--inverted
   * --------------------------------------
   * Text and icon color for neutral status, or to highlight information.
   */
  'ai-text-icon--status-neutral--inverted': Color.rgb([210, 202, 249]).toString(),
  /**
   * ai-text-icon--status-success--inverted
   * --------------------------------------
   * Text and icon color for positive status, success, health.
   */
  'ai-text-icon--status-success--inverted': Color.rgb([44, 105, 53]).toString(),
  /**
   * ai-text-icon--status-warning--inverted
   * --------------------------------------
   * Text and icon color for warnings, minor issues, minor errors.
   */
  'ai-text-icon--status-warning--inverted': Color.rgb([252, 199, 98]).toString(),
  /**
   * ai-text-icon--status-critical--inverted
   * ---------------------------------------
   * Text and icon color for critical information or major issues, danger, destructive action or major error.
   */
  'ai-text-icon--status-critical--inverted': Color.rgb([168, 54, 28]).toString(),
  /**
   * ai-text-icon--status-undefined--inverted
   * ----------------------------------------
   * Text and icon color for undefined state, default, unknown status, no-status.
   */
  'ai-text-icon--status-undefined--inverted': Color.rgb([208, 208, 208]).toString(),
  /**
   * ai-border--muted--inverted
   * --------------------------
   * Default border color for screen dividers and generic non-interactive borders.
   */
  'ai-border--muted--inverted': Color.rgb([81, 81, 81]).toString(),
  /**
   * ai-border--interactive--default--inverted
   * -----------------------------------------
   * Border color for outlined components or controls (e.g. input, select, card).
   */
  'ai-border--interactive--default--inverted': Color.rgb([255, 255, 255]).alpha(0.2).toString(),
  /**
   * ai-border--interactive--default--alt--inverted
   * ----------------------------------------------
   * Alternative border color for small outlined components or controls (e.g. checkbox).
   */
  'ai-border--interactive--default--alt--inverted': Color.rgb([255, 255, 255]).alpha(0.28).toString(),
  /**
   * ai-border--interactive--hover--inverted
   * ---------------------------------------
   * Hover state border color for outlined components or controls.
   */
  'ai-border--interactive--hover--inverted': Color.rgb([178, 161, 244]).toString(),
  /**
   * ai-border--interactive--toggled-default--inverted
   * -------------------------------------------------
   * Toggled (active, selected) state border color for outlined components or controls.
   */
  'ai-border--interactive--toggled-default--inverted': Color.rgb([213, 206, 249]).toString(),
  /**
   * ai-border--interactive--toggled-hover--inverted
   * -----------------------------------------------
   * Hover state of a toggled (active, selected) state border color for outlined components or controls.
   */
  'ai-border--interactive--toggled-hover--inverted': Color.rgb([223, 217, 250]).toString(),
  /**
   * ai-border--interactive--toggled-pressed--inverted
   * -------------------------------------------------
   * Pressed state of a toggled (active, selected) state border color for outlined components or controls.
   */
  'ai-border--interactive--toggled-pressed--inverted': Color.rgb([231, 226, 252]).toString(),
  /**
   * ai-border--interactive--disabled--inverted
   * ------------------------------------------
   * Disabled border color for interactive elements (e.g. checkboxes, selection control, inputs).
   */
  'ai-border--interactive--disabled--inverted': Color.rgb([255, 255, 255]).alpha(0.08).toString(),
  /**
   * ai-border--status-neutral--muted--inverted
   * ------------------------------------------
   * Default (muted) border color for neutral status.
   */
  'ai-border--status-neutral--muted--inverted': Color.rgb([136, 102, 236]).alpha(0.4).toString(),
  /**
   * ai-border--status-neutral--strong--inverted
   * -------------------------------------------
   * Strong (saturated) border color for neutral status.
   */
  'ai-border--status-neutral--strong--inverted': Color.rgb([136, 102, 236]).toString(),
  /**
   * ai-border--status-success--muted--inverted
   * ------------------------------------------
   * Default (muted) border color for success status.
   */
  'ai-border--status-success--muted--inverted': Color.rgb([74, 178, 91]).alpha(0.4).toString(),
  /**
   * ai-border--status-success--strong--inverted
   * -------------------------------------------
   * Strong (saturated) border color for success status.
   */
  'ai-border--status-success--strong--inverted': Color.rgb([74, 178, 91]).toString(),
  /**
   * ai-border--status-warning--muted--inverted
   * ------------------------------------------
   * Default (muted) border color for warning status.
   */
  'ai-border--status-warning--muted--inverted': Color.rgb([255, 187, 0]).alpha(0.4).toString(),
  /**
   * ai-border--status-warning--strong--inverted
   * -------------------------------------------
   * Strong (saturated) border color for warning status.
   */
  'ai-border--status-warning--strong--inverted': Color.rgb([250, 174, 26]).toString(),
  /**
   * ai-border--status-critical--muted--inverted
   * -------------------------------------------
   * Default (muted) border color for critical status.
   */
  'ai-border--status-critical--muted--inverted': Color.rgb([238, 76, 40]).alpha(0.4).toString(),
  /**
   * ai-border--status-critical--strong--inverted
   * --------------------------------------------
   * Strong (saturated) border color for critical status.
   */
  'ai-border--status-critical--strong--inverted': Color.rgb([238, 76, 40]).toString(),
  /**
   * ai-border--status-undefined--muted--inverted
   * --------------------------------------------
   * Default (muted) border color for undefined status.
   */
  'ai-border--status-undefined--muted--inverted': Color.rgb([79, 79, 79]).alpha(0.4).toString(),
  /**
   * ai-border--status-undefined--strong--inverted
   * ---------------------------------------------
   * Strong (saturated) border color for undefined status.
   */
  'ai-border--status-undefined--strong--inverted': Color.rgb([79, 79, 79]).toString(),
  /**
   * ai-surface--muted--inverted
   * ---------------------------
   * Default surface color for screens (pages) and UI background.
   */
  'ai-surface--muted--inverted': Color.rgb([24, 25, 31]).toString(),
  /**
   * ai-surface--medium--inverted
   * ----------------------------
   * Alternative surface color for sreens (pages) and UI background. Also used forstriped tables.
   */
  'ai-surface--medium--inverted': Color.rgb([36, 37, 45]).toString(),
  /**
   * ai-surface--strong--inverted
   * ----------------------------
   * Accent surface color for screens (pages) and UI background. Used tohelp cards and islands on-top stand out more.
   */
  'ai-surface--strong--inverted': Color.rgb([48, 50, 60]).toString(),
  /**
   * ai-surface--misc-transparent--inverted
   * --------------------------------------
   * Transparent surface token.
   */
  'ai-surface--misc-transparent--inverted': Color.rgb([0, 0, 0]).alpha(0).toString(),
  /**
   * ai-surface--misc-backdrop--inverted
   * -----------------------------------
   * Surface color for backdrops behind modal windows.
   */
  'ai-surface--misc-backdrop--inverted': Color.rgb([71, 71, 71]).alpha(0.3).toString(),
  /**
   * ai-surface--misc-canvas--inverted
   * ---------------------------------
   * Surface color for canvases, interactive boards, pipelines, document editors.
   */
  'ai-surface--misc-canvas--inverted': Color.rgb([245, 245, 245]).toString(),
  /**
   * ai-surface--misc-code--muted--inverted
   * --------------------------------------
   * Surface color for code editors and code examples (snippets)
   */
  'ai-surface--misc-code--muted--inverted': Color.rgb([56, 55, 61]).toString(),
  /**
   * ai-surface--misc-code--medium--inverted
   * ---------------------------------------
   * Surface color for decorative elements of code editors and code examples (snippets)
   */
  'ai-surface--misc-code--medium--inverted': Color.rgb([67, 65, 72]).toString(),
  /**
   * ai-surface--interactive--hover--inverted
   * ----------------------------------------
   * Generic hover state surface color for interactive elements without any specified background (e.g. table rows).
   */
  'ai-surface--interactive--hover--inverted': Color.rgb([255, 255, 255]).alpha(0.06).toString(),
  /**
   * ai-surface--interactive--pressed--inverted
   * ------------------------------------------
   * Generic pressed state surface color for interactive elements without any specified background (e.g. table rows).
   */
  'ai-surface--interactive--pressed--inverted': Color.rgb([255, 255, 255]).alpha(0.1).toString(),
  /**
   * ai-surface--interactive--toggled-default--inverted
   * --------------------------------------------------
   * Toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'ai-surface--interactive--toggled-default--inverted': Color.rgb([145, 117, 238]).alpha(0.08).toString(),
  /**
   * ai-surface--interactive--toggled-hover--inverted
   * ------------------------------------------------
   * Hover state of a toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'ai-surface--interactive--toggled-hover--inverted': Color.rgb([145, 117, 238]).alpha(0.14).toString(),
  /**
   * ai-surface--interactive--toggled-pressed--inverted
   * --------------------------------------------------
   * Pressed state of a toggled state surface color for selected or active elements (e.g. table rows, buttons).
   */
  'ai-surface--interactive--toggled-pressed--inverted': Color.rgb([145, 117, 238]).alpha(0.18).toString(),
  /**
   * ai-surface--interactive--disabled--inverted
   * -------------------------------------------
   * Disabled state surface color for interactive elements (e.g. buttons, inputs).
   */
  'ai-surface--interactive--disabled--inverted': Color.rgb([255, 255, 255]).alpha(0.08).toString(),
  /**
   * ai-surface--interactive--disabled--alt--inverted
   * ------------------------------------------------
   * Alternative disabled state surface color for duo-toned components (e.g. checkbox)
   */
  'ai-surface--interactive--disabled--alt--inverted': Color.rgb([255, 255, 255]).alpha(0.12).toString(),
  /**
   * ai-surface--action--strong--default--inverted
   * ---------------------------------------------
   * Surface color for primary actions (e.g. primary button).
   */
  'ai-surface--action--strong--default--inverted': Color.rgb([171, 153, 243]).toString(),
  /**
   * ai-surface--action--strong--hover--inverted
   * -------------------------------------------
   * Hover state surface color for primary actions (e.g. primary button).
   */
  'ai-surface--action--strong--hover--inverted': Color.rgb([180, 165, 244]).toString(),
  /**
   * ai-surface--action--strong--pressed--inverted
   * ---------------------------------------------
   * Pressed state surface color for primary actions (e.g. primary button).
   */
  'ai-surface--action--strong--pressed--inverted': Color.rgb([188, 175, 246]).toString(),
  /**
   * ai-surface--action--muted--default--inverted
   * --------------------------------------------
   * Surface color for secondary actions components (e.g. secondary button).
   */
  'ai-surface--action--muted--default--inverted': Color.rgb([255, 255, 255]).alpha(0.06).toString(),
  /**
   * ai-surface--action--muted--default--alt--inverted
   * -------------------------------------------------
   * Alternative surface color for smaller secondary actions components (e.g. switch).
   */
  'ai-surface--action--muted--default--alt--inverted': Color.rgb([255, 255, 255]).alpha(0.32).toString(),
  /**
   * ai-surface--action--muted--hover--inverted
   * ------------------------------------------
   * Hover state surface color for secondary actions (e.g. secondary button).
   */
  'ai-surface--action--muted--hover--inverted': Color.rgb([255, 255, 255]).alpha(0.08).toString(),
  /**
   * ai-surface--action--muted--pressed--inverted
   * --------------------------------------------
   * Pressed state surface color for secondary actions (e.g. secondary button).
   */
  'ai-surface--action--muted--pressed--inverted': Color.rgb([255, 255, 255]).alpha(0.1).toString(),
  /**
   * ai-surface--on--action--muted--default--inverted
   * ------------------------------------------------
   * Default state surface color to be used on top of secondary actions (e.g. segmented control).
   */
  'ai-surface--on--action--muted--default--inverted': Color.rgb([255, 255, 255]).alpha(0.33).toString(),
  /**
   * ai-surface--on--action--muted--hover--inverted
   * ----------------------------------------------
   * Hover state surface color to be used on top of secondary actions (e.g. segmented control).
   */
  'ai-surface--on--action--muted--hover--inverted': Color.rgb([255, 255, 255]).alpha(0.28).toString(),
  /**
   * ai-surface--status-neutral--muted--default--inverted
   * ----------------------------------------------------
   * Default (muted) surface color for neutral status. Used for smaller elements like label.
   */
  'ai-surface--status-neutral--muted--default--inverted': Color.rgb([111, 59, 228]).alpha(0.12).toString(),
  /**
   * ai-surface--status-neutral--muted--default--alt--inverted
   * ---------------------------------------------------------
   * Alternative muted surface color for neutral status. Used for bigger elements like infobox.
   */
  'ai-surface--status-neutral--muted--default--alt--inverted': Color.rgb([111, 59, 228]).alpha(0.08).toString(),
  /**
   * ai-surface--status-neutral--muted--hover--inverted
   * --------------------------------------------------
   * Hover state of a muted surface color for neutral status.
   */
  'ai-surface--status-neutral--muted--hover--inverted': Color.rgb([111, 59, 228]).alpha(0.16).toString(),
  /**
   * ai-surface--status-neutral--muted--pressed--inverted
   * ----------------------------------------------------
   * Pressed state of a muted surface color for neutral status.
   */
  'ai-surface--status-neutral--muted--pressed--inverted': Color.rgb([111, 59, 228]).alpha(0.2).toString(),
  /**
   * ai-surface--status-neutral--strong--default--inverted
   * -----------------------------------------------------
   * Strong (saturated) surface color for neutral status.
   */
  'ai-surface--status-neutral--strong--default--inverted': Color.rgb([172, 154, 243]).toString(),
  /**
   * ai-surface--status-neutral--strong--hover--inverted
   * ---------------------------------------------------
   * Hover state of a strong (saturated) surface color for neutral status.
   */
  'ai-surface--status-neutral--strong--hover--inverted': Color.rgb([181, 165, 244]).toString(),
  /**
   * ai-surface--status-neutral--strong--pressed--inverted
   * -----------------------------------------------------
   * Pressed state of a strong (saturated) surface color for neutral status.
   */
  'ai-surface--status-neutral--strong--pressed--inverted': Color.rgb([188, 175, 246]).toString(),
  /**
   * ai-surface--status-success--muted--default--inverted
   * ----------------------------------------------------
   * Default (muted) surface color for success status. Used for smaller elements like label.
   */
  'ai-surface--status-success--muted--default--inverted': Color.rgb([74, 178, 91]).alpha(0.16).toString(),
  /**
   * ai-surface--status-success--muted--default--alt--inverted
   * ---------------------------------------------------------
   * Alternative muted surface color for success status. Used for bigger elements like infobox.
   */
  'ai-surface--status-success--muted--default--alt--inverted': Color.rgb([74, 178, 91]).alpha(0.12).toString(),
  /**
   * ai-surface--status-success--muted--hover--inverted
   * --------------------------------------------------
   * Hover state of a muted surface color for success status.
   */
  'ai-surface--status-success--muted--hover--inverted': Color.rgb([74, 178, 91]).alpha(0.2).toString(),
  /**
   * ai-surface--status-success--muted--pressed--inverted
   * ----------------------------------------------------
   * Pressed state of a muted surface color for success status.
   */
  'ai-surface--status-success--muted--pressed--inverted': Color.rgb([57, 162, 99]).alpha(0.22).toString(),
  /**
   * ai-surface--status-success--strong--default--inverted
   * -----------------------------------------------------
   * Strong (saturated) surface color for success status.
   */
  'ai-surface--status-success--strong--default--inverted': Color.rgb([93, 186, 108]).toString(),
  /**
   * ai-surface--status-success--strong--hover--inverted
   * ---------------------------------------------------
   * Hover state of a strong (saturated) surface color for success status.
   */
  'ai-surface--status-success--strong--hover--inverted': Color.rgb([111, 194, 123]).toString(),
  /**
   * ai-surface--status-success--strong--pressed--inverted
   * -----------------------------------------------------
   * Pressed state of a strong (saturated) surface color for success status.
   */
  'ai-surface--status-success--strong--pressed--inverted': Color.rgb([128, 201, 139]).toString(),
  /**
   * ai-surface--status-warning--muted--default--inverted
   * ----------------------------------------------------
   * Default (muted) surface color for warning status. Used for smaller elements like label.
   */
  'ai-surface--status-warning--muted--default--inverted': Color.rgb([250, 174, 26]).alpha(0.16).toString(),
  /**
   * ai-surface--status-warning--muted--default--alt--inverted
   * ---------------------------------------------------------
   * Alternative muted surface color for warning status. Used for bigger elements like infobox.
   */
  'ai-surface--status-warning--muted--default--alt--inverted': Color.rgb([250, 174, 26]).alpha(0.12).toString(),
  /**
   * ai-surface--status-warning--muted--hover--inverted
   * --------------------------------------------------
   * Hover state of a muted surface color for warning status.
   */
  'ai-surface--status-warning--muted--hover--inverted': Color.rgb([250, 174, 26]).alpha(0.2).toString(),
  /**
   * ai-surface--status-warning--muted--pressed--inverted
   * ----------------------------------------------------
   * Pressed state of a muted surface color for warning status.
   */
  'ai-surface--status-warning--muted--pressed--inverted': Color.rgb([250, 174, 26]).alpha(0.22).toString(),
  /**
   * ai-surface--status-warning--strong--default--inverted
   * -----------------------------------------------------
   * Strong (saturated) surface color for warning status.
   */
  'ai-surface--status-warning--strong--default--inverted': Color.rgb([221, 154, 23]).toString(),
  /**
   * ai-surface--status-warning--strong--hover--inverted
   * ---------------------------------------------------
   * Hover state of a strong (saturated) surface color for warning status.
   */
  'ai-surface--status-warning--strong--hover--inverted': Color.rgb([233, 162, 24]).toString(),
  /**
   * ai-surface--status-warning--strong--pressed--inverted
   * -----------------------------------------------------
   * Pressed state of a strong (saturated) surface color for warning status.
   */
  'ai-surface--status-warning--strong--pressed--inverted': Color.rgb([245, 170, 25]).toString(),
  /**
   * ai-surface--status-critical--muted--default--inverted
   * -----------------------------------------------------
   * Default (muted) surface color for critical status. Used for smaller elements like label.
   */
  'ai-surface--status-critical--muted--default--inverted': Color.rgb([238, 76, 40]).alpha(0.16).toString(),
  /**
   * ai-surface--status-critical--muted--default--alt--inverted
   * ----------------------------------------------------------
   * Alternative muted surface color for critical status. Used for bigger elements like infobox.
   */
  'ai-surface--status-critical--muted--default--alt--inverted': Color.rgb([238, 76, 40]).alpha(0.2).toString(),
  /**
   * ai-surface--status-critical--muted--hover--inverted
   * ---------------------------------------------------
   * Hover state of a muted surface color for critical status.
   */
  'ai-surface--status-critical--muted--hover--inverted': Color.rgb([238, 76, 40]).alpha(0.12).toString(),
  /**
   * ai-surface--status-critical--muted--pressed--inverted
   * -----------------------------------------------------
   * Pressed state of a muted surface color for critical status.
   */
  'ai-surface--status-critical--muted--pressed--inverted': Color.rgb([238, 76, 40]).alpha(0.22).toString(),
  /**
   * ai-surface--status-critical--strong--default--inverted
   * ------------------------------------------------------
   * Strong (saturated) surface color for critical status.
   */
  'ai-surface--status-critical--strong--default--inverted': Color.rgb([243, 138, 115]).toString(),
  /**
   * ai-surface--status-critical--strong--hover--inverted
   * ----------------------------------------------------
   * Hover state of a strong (saturated) surface color for critical status.
   */
  'ai-surface--status-critical--strong--hover--inverted': Color.rgb([245, 151, 131]).toString(),
  /**
   * ai-surface--status-critical--strong--pressed--inverted
   * ------------------------------------------------------
   * Pressed state of a strong (saturated) surface color for critical status.
   */
  'ai-surface--status-critical--strong--pressed--inverted': Color.rgb([246, 164, 146]).toString(),
  /**
   * ai-surface--status-undefined--muted--default--inverted
   * ------------------------------------------------------
   * Default (muted) surface color for undefined status. Used for smaller elements like label.
   */
  'ai-surface--status-undefined--muted--default--inverted': Color.rgb([79, 79, 79]).alpha(0.4).toString(),
  /**
   * ai-surface--status-undefined--muted--default--alt--inverted
   * -----------------------------------------------------------
   * Alternative muted surface color for undefined status. Used for bigger elements like infobox.
   */
  'ai-surface--status-undefined--muted--default--alt--inverted': Color.rgb([79, 79, 79]).alpha(0.12).toString(),
  /**
   * ai-surface--status-undefined--muted--hover--inverted
   * ----------------------------------------------------
   * Hover state of a muted surface color for undefined status.
   */
  'ai-surface--status-undefined--muted--hover--inverted': Color.rgb([79, 79, 79]).alpha(0.2).toString(),
  /**
   * ai-surface--status-undefined--muted--pressed--inverted
   * ------------------------------------------------------
   * Pressed state of a muted surface color for undefined status.
   */
  'ai-surface--status-undefined--muted--pressed--inverted': Color.rgb([79, 79, 79]).alpha(0.22).toString(),
  /**
   * ai-surface--status-undefined--strong--default--inverted
   * -------------------------------------------------------
   * Strong (saturated) surface color for undefined status.
   */
  'ai-surface--status-undefined--strong--default--inverted': Color.rgb([167, 167, 167]).toString(),
  /**
   * ai-surface--status-undefined--strong--hover--inverted
   * -----------------------------------------------------
   * Hover state of a strong (saturated) surface color for undefined status.
   */
  'ai-surface--status-undefined--strong--hover--inverted': Color.rgb([176, 176, 176]).toString(),
  /**
   * ai-surface--status-undefined--strong--pressed--inverted
   * -------------------------------------------------------
   * Pressed state of a strong (saturated) surface color for undefined status.
   */
  'ai-surface--status-undefined--strong--pressed--inverted': Color.rgb([184, 184, 184]).toString()
};
var gradientTokens = {};

export { aiTokens, colorTokens, gradientTokens };
